/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as t from "react";
import r from "prop-types";
import { Keys as C, classNames as k, IconWrap as Q, getActiveElement as Ut, validatePackage as W, dispatchEvent as q, shouldShowValidationUI as ze, WatermarkOverlay as Fe, Draggable as lt, svgIconPropType as De, kendoThemeMaps as Ge, toIconName as jt, getTabIndex as Oe, useDir as ve, focusFirstFocusableChild as ke, useRtl as Vt, useId as ye, canUseDOM as qt, getter as qn, FOCUSABLE_ELEMENTS as Gn, Navigation as ct, SvgIcon as Xe, useAsyncFocusBlur as Xn, withIdHOC as Gt } from "@progress/kendo-react-common";
import { Popup as Xt } from "@progress/kendo-react-popup";
import { caretAltLeftIcon as ae, caretAltRightIcon as oe, caretAltDownIcon as Ae, caretAltUpIcon as Ye, chevronUpIcon as Yt, chevronDownIcon as Zt, checkOutlineIcon as Yn, exclamationCircleIcon as Zn, chevronLeftIcon as Jn, chevronRightIcon as Jt } from "@progress/kendo-svg-icons";
import { Button as Qn } from "@progress/kendo-react-buttons";
import { Fade as es, Reveal as Qt, Animation as ts } from "@progress/kendo-react-animation";
import { provideLocalizationService as ns, useLocalization as en, useInternationalization as tn } from "@progress/kendo-react-intl";
import { ProgressBar as ss } from "@progress/kendo-react-progressbars";
const X = "", Be = "0", ie = "_";
function Re(e, s) {
  if (J(e))
    return s[Number(e)];
  {
    const n = s[Number(ge(e))];
    return n.items ? Re(is(e), n.items) : void 0;
  }
}
function ge(e) {
  return be(e) ? e : e.split(ie)[0];
}
function is(e) {
  if (be(e))
    return e;
  {
    const s = e.indexOf(ie);
    return e.substring(s + 1);
  }
}
function Lt(e) {
  return Ke("0", e);
}
function rs(e, s) {
  return s.indexOf(e) === 0 ? s.length === e.length || s.charAt(e.length) === ie : !1;
}
function Ke(e, s) {
  return s ? s + ie + e : e;
}
function pe(e) {
  const s = e.lastIndexOf(ie);
  return s < 0 ? X : e.substring(0, s);
}
function be(e) {
  return e === X || e.indexOf(ie) < 0;
}
function J(e) {
  return e !== X && e.indexOf(ie) < 0;
}
function as(e) {
  return ls(e) === 1;
}
function os(e) {
  return Ze(e) === Be;
}
function Ze(e) {
  const s = e.lastIndexOf(ie);
  return s < 0 ? e : e.substring(s + 1);
}
function At(e, s, n) {
  return J(s) ? e ? Number(s) < n - 1 ? (Number(s) + 1).toString() : "0" : Number(s) > 0 ? (Number(s) - 1).toString() : (n - 1).toString() : s;
}
function ls(e) {
  return e.split(ie).length - 1;
}
class nn extends t.Component {
  /**
   * @hidden
   */
  render() {
    return null;
  }
}
nn.propTypes = {
  text: r.string,
  url: r.string,
  icon: r.string,
  disabled: r.bool,
  cssClass: r.string,
  cssStyle: r.object,
  render: r.any,
  linkRender: r.any,
  contentRender: r.any,
  data: r.any
};
function cs(e, s) {
  if (e && e.length > 0)
    return {
      items: Qe(e),
      inputItems: e
    };
  if (Je(s).length > 0) {
    const n = rn(Je(s));
    return { items: Qe(n), inputItems: n };
  } else
    return { items: [], inputItems: [] };
}
function sn(e, s) {
  let n = {};
  const { text: i, url: a, icon: o, svgIcon: l, disabled: c, cssClass: d, cssStyle: u, render: m, linkRender: h, contentRender: p, data: g } = e || s.props;
  return i !== void 0 && (n.text = i), a !== void 0 && (n.url = a), o !== void 0 && (n.icon = o), l !== void 0 && (n.svgIcon = l), c !== void 0 && (n.disabled = c), d !== void 0 && (n.cssClass = d), u !== void 0 && (n.cssStyle = u), m !== void 0 && (n.render = m), h !== void 0 && (n.linkRender = h), p !== void 0 && (n.contentRender = p), g !== void 0 && (n.data = g), n;
}
function Je(e) {
  return t.Children.toArray(e).filter((s) => s && s.type === nn);
}
function rn(e) {
  const s = [];
  for (let n = 0; n < e.length; n++) {
    const i = e[n], a = sn(void 0, i), o = rn(Je(i.props.children));
    o.length > 0 && (a.items = o), s.push(a);
  }
  return s;
}
function Qe(e, s) {
  const n = [];
  for (let i = 0; i < e.length; i++) {
    const a = e[i], o = sn(a);
    o.id = Ke(i.toString(), s), o.isLastFromSiblings = i === e.length - 1, o.items = ds(a, o), n.push(o);
  }
  return n;
}
function ds(e, s) {
  return e.contentRender ? [{
    contentParentItemId: s.id,
    id: Ke(Be, s.id),
    isLastFromSiblings: !0,
    contentRender: e.contentRender,
    items: []
  }] : e.items ? Qe(e.items, s.id) : [];
}
const us = /\S/;
function ms(e, s, n, i, a, o) {
  const l = O();
  switch (n) {
    case C.left:
      return c();
    case C.right:
      return d();
    case C.up:
      return m();
    case C.down:
      return u();
    case C.enter:
    case C.space:
      return h();
    case C.home:
      return p();
    case C.end:
      return g();
    case C.esc:
      return b();
    default:
      return S() ? y() : s;
  }
  function c() {
    return a ? o ? R() : N() : o ? f() : E();
  }
  function d() {
    return a ? o ? N() : R() : o ? E() : f();
  }
  function u() {
    return a ? L() : J(s) ? v() : L();
  }
  function m() {
    return a ? D() : J(s) ? w() : D();
  }
  function h() {
    return l.disabled ? s : A() ? Lt(s) : ge(s);
  }
  function p() {
    return G()[0].id;
  }
  function g() {
    const x = G();
    return x[x.length - 1].id;
  }
  function b() {
    return J(s) ? s : pe(s);
  }
  function y() {
    const x = i.toLowerCase(), M = G(), j = Number(Ze(s)), Z = M.slice(j + 1).concat(M.slice(0, j + 1)).find((re) => (re.text || "").toLowerCase().startsWith(x));
    return Z ? Z.id : s;
  }
  function E() {
    return J(s) ? D() : as(s) ? v(D(ge(s))) : pe(s);
  }
  function N() {
    return J(s) ? w() : pe(s);
  }
  function f() {
    return J(s) ? L() : v(
      A() ? s : L(ge(s))
    );
  }
  function R() {
    return v(
      J(s) || A() ? s : L(ge(s))
    );
  }
  function v(x) {
    return ee(!0, x);
  }
  function w(x) {
    return ee(!1, x);
  }
  function S() {
    return i.length === 1 && us.test(i);
  }
  function O(x, M) {
    return x === void 0 && (x = s), M === void 0 && (M = e), Re(x, M);
  }
  function A(x) {
    return O(x).items.length > 0;
  }
  function D(x) {
    return $(!1, x);
  }
  function L(x) {
    return $(!0, x);
  }
  function B(x) {
    const M = O(x).items;
    return M[M.length - 1].id;
  }
  function G() {
    return J(s) ? e : O(pe(s), e).items;
  }
  function ee(x, M) {
    M === void 0 && (M = s);
    const j = O(M);
    return A(M) && !j.disabled ? x ? Lt(M) : B(M) : M;
  }
  function $(x, M) {
    if (M === void 0 && (M = s), J(M))
      return At(x, M, e.length);
    {
      const j = pe(M), Y = Ze(M), Z = O(j).items.length;
      return Ke(At(x, Y, Z), j);
    }
  }
}
function hs(e) {
  return e.hoverOpenDelay !== void 0 ? e.hoverOpenDelay : e.openOnClick ? 0 : 100;
}
function ps(e) {
  return e.hoverCloseDelay !== void 0 ? e.hoverCloseDelay : 100;
}
const zt = {
  vertical: "top",
  horizontal: "left"
}, Ft = {
  vertical: "top",
  horizontal: "right"
}, an = {
  vertical: "flip",
  horizontal: "fit"
}, on = {
  vertical: "fit",
  horizontal: "flip"
}, Bt = {
  downward: {
    anchorAlign: {
      vertical: "bottom",
      horizontal: "right"
    },
    popupAlign: Ft,
    collision: an
  },
  leftward: {
    anchorAlign: {
      vertical: "top",
      horizontal: "left"
    },
    popupAlign: Ft,
    collision: on
  }
}, Kt = {
  downward: {
    anchorAlign: {
      vertical: "bottom",
      horizontal: "left"
    },
    popupAlign: zt,
    collision: an
  },
  rightward: {
    anchorAlign: {
      vertical: "top",
      horizontal: "right"
    },
    popupAlign: zt,
    collision: on
  }
};
function fs(e, s, n) {
  const i = ln(e, s, n);
  return n ? i === "downward" ? Bt.downward : Bt.leftward : i === "downward" ? Kt.downward : Kt.rightward;
}
function ln(e, s, n) {
  return J(e) ? s ? n ? "leftward" : "rightward" : "downward" : n ? "leftward" : "rightward";
}
function Ht(e) {
  return e ? "rtl" : "ltr";
}
function et(e, s) {
  return `${e}_${s}`;
}
class cn extends t.Component {
  /**
   * @hidden
   */
  render() {
    return this.props.url ? /* @__PURE__ */ t.createElement(
      "a",
      {
        className: this.getMenuItemClassName(),
        role: "presentation",
        href: this.props.url,
        tabIndex: -1
      },
      this.props.children
    ) : /* @__PURE__ */ t.createElement(
      "span",
      {
        id: this.props.id,
        className: k(this.getMenuItemClassName(), this.props.className),
        style: this.props.style,
        role: "presentation"
      },
      this.props.children
    );
  }
  getMenuItemClassName() {
    return k(
      "k-link",
      "k-menu-link",
      {
        "k-active": this.props.opened
      }
    );
  }
}
cn.propTypes = {
  opened: r.bool,
  url: r.string
};
const gs = "caret-alt-down", bs = "caret-alt-right", vs = "caret-alt-left";
class dn extends t.Component {
  /**
   * @hidden
   */
  render() {
    return /* @__PURE__ */ t.createElement(Q, { "aria-hidden": !0, ...this.getIcon() });
  }
  getIcon() {
    switch (ln(
      this.props.itemId,
      this.props.verticalMenu === !0,
      this.props.dir === "rtl"
    )) {
      case "downward":
        return { name: gs, icon: Ae };
      case "rightward":
        return { name: bs, icon: oe };
      case "leftward":
        return { name: vs, icon: ae };
      default:
        return {};
    }
  }
}
dn.propTypes = {
  itemId: r.string,
  dir: r.string,
  verticalMenu: r.bool
};
class un extends t.Component {
  constructor() {
    super(...arguments), this.onMouseOver = (s) => {
      this.props.onMouseOver(this.props.parentItemId), s.stopPropagation();
    }, this.onMouseLeave = (s) => {
      this.props.onMouseLeave(this.props.parentItemId), s.stopPropagation();
    };
  }
  render() {
    const s = this.props.parentItemId;
    return /* @__PURE__ */ t.createElement(
      "ul",
      {
        className: this.props.className,
        role: this.props.role ? this.props.role : s !== void 0 ? "menu" : "menubar",
        id: s !== void 0 ? et(this.props.menuGuid, s) : void 0,
        onMouseOver: s !== void 0 ? this.onMouseOver : void 0,
        onMouseLeave: s !== void 0 ? this.onMouseLeave : void 0,
        "aria-orientation": this.props["aria-orientation"]
      },
      this.renderChildItems()
    );
  }
  renderChildItems() {
    return this.props.items.length > 0 ? this.props.items.map((s, n) => /* @__PURE__ */ t.createElement(
      ks,
      {
        item: s,
        isMenuVertical: this.props.isMenuVertical,
        isDirectionRightToLeft: this.props.isDirectionRightToLeft,
        focusedItemId: this.props.focusedItemId,
        lastItemIdToBeOpened: this.props.lastItemIdToBeOpened,
        tabbableItemId: this.props.tabbableItemId,
        itemRender: this.props.itemRender,
        linkRender: this.props.linkRender,
        menuGuid: this.props.menuGuid,
        onMouseOver: this.props.onMouseOver,
        onMouseLeave: this.props.onMouseLeave,
        onMouseDown: this.props.onMouseDown,
        onBlur: this.props.onBlur,
        onFocus: this.props.onFocus,
        onClick: this.props.onClick,
        onOriginalItemNeeded: this.props.onOriginalItemNeeded,
        key: n
      }
    )) : null;
  }
}
class ks extends t.Component {
  constructor(s) {
    super(s), this.isFirstRender = !0, this.onMouseOver = (n) => {
      this.props.onMouseOver(this.props.item.id), n.stopPropagation();
    }, this.onMouseLeave = (n) => {
      this.props.onMouseLeave(this.props.item.id), n.stopPropagation();
    }, this.state = { opened: !1 };
  }
  componentDidMount() {
    const s = this.props.focusedItemId, n = this.props.item.id;
    s && s === n && this.itemElement.focus(), this.isFirstRender = !1;
  }
  componentDidUpdate(s) {
    const n = this.props.focusedItemId, i = this.props.item.id;
    if (n) {
      const a = Ut(document);
      s.focusedItemId !== n && n === i && !this.itemElement.contains(a) && this.itemElement.focus();
    }
  }
  render() {
    const s = this.props.item, n = s.id, i = et(this.props.menuGuid, n);
    return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "li",
      {
        id: et(this.props.menuGuid, n),
        className: this.getMenuItemClassName(s),
        style: s.cssStyle,
        tabIndex: n === this.props.tabbableItemId ? 0 : -1,
        onMouseOver: this.onMouseOver,
        onMouseLeave: this.onMouseLeave,
        onMouseDown: (a) => this.props.onMouseDown(a),
        onBlur: (a) => this.props.onBlur(n, a),
        onFocus: () => this.props.onFocus(n),
        onClick: (a) => this.props.onClick(a, n),
        role: "menuitem",
        "aria-disabled": s.disabled ? !0 : void 0,
        "aria-haspopup": s.items.length > 0 ? !0 : void 0,
        "aria-expanded": s.items.length > 0 ? this.Opened : void 0,
        "aria-label": s.text,
        "aria-owns": this.Opened ? i : void 0,
        ref: (a) => this.itemElement = a,
        key: "0"
      },
      this.contentRender ? this.renderContent() : this.renderMenuItemLink()
    ), this.renderPopupIfOpened());
  }
  renderContent() {
    const s = this.props.item.contentParentItemId;
    return /* @__PURE__ */ t.createElement("div", { className: "k-content", role: "presentation" }, /* @__PURE__ */ t.createElement(this.contentRender, { item: this.props.onOriginalItemNeeded(s), itemId: s }));
  }
  renderMenuItemLink() {
    const s = this.props.item;
    if (this.linkRender)
      return /* @__PURE__ */ t.createElement(
        this.linkRender,
        {
          item: this.props.onOriginalItemNeeded(s.id),
          itemId: s.id,
          opened: this.Opened,
          dir: Ht(this.props.isDirectionRightToLeft)
        }
      );
    {
      const n = this.itemRender ? /* @__PURE__ */ t.createElement(this.itemRender, { item: this.props.onOriginalItemNeeded(s.id), itemId: s.id, key: "1" }) : /* @__PURE__ */ t.createElement("span", { className: "k-menu-link-text" }, s.text);
      return /* @__PURE__ */ t.createElement(cn, { url: s.url, opened: this.Opened }, this.renderMenuIconIfApplicable(), n, this.renderArrowIfApplicable());
    }
  }
  renderPopupIfOpened() {
    if (this.Opened) {
      const s = this.props.item.id, { anchorAlign: n, popupAlign: i, collision: a } = fs(s, this.props.isMenuVertical, this.props.isDirectionRightToLeft);
      return /* @__PURE__ */ t.createElement(
        Xt,
        {
          anchor: this.itemElement,
          show: !0,
          popupClass: this.getPopupClassName(),
          anchorAlign: n,
          popupAlign: i,
          collision: a,
          animate: !1,
          key: "1"
        },
        /* @__PURE__ */ t.createElement(
          un,
          {
            parentItemId: s,
            items: this.props.item.items,
            menuGuid: this.props.menuGuid,
            focusedItemId: this.props.focusedItemId,
            lastItemIdToBeOpened: this.props.lastItemIdToBeOpened,
            tabbableItemId: this.props.tabbableItemId,
            itemRender: this.props.itemRender,
            linkRender: this.props.linkRender,
            isMenuVertical: this.props.isMenuVertical,
            isDirectionRightToLeft: this.props.isDirectionRightToLeft,
            className: "k-group k-menu-group k-reset k-menu-group-md",
            onMouseOver: this.props.onMouseOver,
            onMouseLeave: this.props.onMouseLeave,
            onMouseDown: this.props.onMouseDown,
            onBlur: this.props.onBlur,
            onFocus: this.props.onFocus,
            onClick: this.props.onClick,
            onOriginalItemNeeded: this.props.onOriginalItemNeeded
          }
        )
      );
    } else
      return null;
  }
  renderMenuIconIfApplicable() {
    const { icon: s, svgIcon: n } = this.props.item;
    return s || n ? /* @__PURE__ */ t.createElement(Q, { name: s, icon: n, key: "0" }) : null;
  }
  renderArrowIfApplicable() {
    return this.props.item.items.length > 0 ? /* @__PURE__ */ t.createElement("span", { className: "k-menu-expand-arrow", "aria-hidden": !0 }, /* @__PURE__ */ t.createElement(
      dn,
      {
        itemId: this.props.item.id,
        verticalMenu: this.props.isMenuVertical,
        dir: Ht(this.props.isDirectionRightToLeft),
        key: "2"
      }
    )) : null;
  }
  get itemRender() {
    return this.props.item.render || this.props.itemRender;
  }
  get linkRender() {
    return this.props.item.linkRender || this.props.linkRender;
  }
  get contentRender() {
    return this.props.item.contentParentItemId ? this.props.item.contentRender : null;
  }
  get Opened() {
    const s = this.props;
    return s.item.items.length > 0 && rs(s.item.id, s.lastItemIdToBeOpened) && // HACK: Wait for the second render because otherwise the scenario of
    // popup inside popup throws an error (for example, hover of item with id '0_0').
    !this.isFirstRender;
  }
  getPopupClassName() {
    return k("k-menu-popup", { "k-rtl": this.props.isDirectionRightToLeft });
  }
  getMenuItemClassName(s) {
    return k(
      "k-item",
      "k-menu-item",
      {
        "k-first": os(s.id),
        "k-last": s.isLastFromSiblings,
        "k-disabled": s.disabled
      },
      s.cssClass
    );
  }
}
class ys {
  constructor() {
    this.phase = "Initialized";
  }
  getIsDirectionRightToLeft() {
    return this.isDirectionRightToLeft;
  }
  setIsDirectionRightToLeft(s) {
    this.phase = this.phase === "NotInitialized" ? "Initialized" : "NewValueReceived", this.previousIsDirectionRightToLeft = this.isDirectionRightToLeft, this.isDirectionRightToLeft = s;
  }
  hasDirectionChanged() {
    return this.phase === "NewValueReceived" ? this.previousIsDirectionRightToLeft !== this.isDirectionRightToLeft : !1;
  }
}
class Is {
  constructor(s, n, i) {
    this.openOnClick = s, this.resetMenu = n, this.openItem = i, this.mouseDown = !1, this.openOnClick = s, this.isMouseOverEnabled = !s;
  }
  set OpenOnClick(s) {
    !!s != !!this.openOnClick && (this.mouseDown = !1, this.isMouseOverEnabled = !s), this.openOnClick = s;
  }
  handleItemSelectedViaKeyboard() {
    this.openOnClick && (this.isMouseOverEnabled = !1, this.resetMenu());
  }
  get IsMouseOverEnabled() {
    return this.isMouseOverEnabled;
  }
  handleItemMouseDown() {
    this.mouseDown = !0;
  }
  handleItemFocus() {
    this.openOnClick && !this.mouseDown && (this.isMouseOverEnabled = !0), this.mouseDown = !1;
  }
  handleItemClick(s, n) {
    this.openOnClick && (this.isMouseOverEnabled ? n && (this.isMouseOverEnabled = !1, this.resetMenu()) : (this.isMouseOverEnabled = !0, this.openItem(s)));
  }
}
const K = {
  name: "@progress/kendo-react-layout",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702644697,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/"
}, _t = {
  focusedItemId: X,
  hoveredItemId: X,
  tabbableItemId: Be
};
let He = class extends t.Component {
  constructor(s) {
    super(s), this.menuWrapperEl = null, this.directionHolder = new ys(), this.inputItems = [], this.items = [], this.reset = () => {
      this.clearItemHoverAndLeaveRequestsIfApplicable(), this.setState(_t);
    }, this.onKeyDown = (n) => {
      if (this.state.focusedItemId !== X) {
        const i = Re(this.state.focusedItemId, this.items), a = ms(
          this.items,
          i.id,
          n.keyCode,
          n.key,
          this.props.vertical,
          this.directionHolder.getIsDirectionRightToLeft()
        );
        i.id !== a && (n.preventDefault(), this.setFocusedItemId(a)), (n.keyCode === C.enter || n.keyCode === C.space) && !i.disabled && (this.mouseOverHandler.handleItemSelectedViaKeyboard(), this.dispatchSelectEventIfWired(n, i.id), !n.isDefaultPrevented() && i.items.length === 0 && i.url && window.location.assign(i.url));
      }
      n.keyCode === C.esc && this.props.onClose && this.props.onClose.call(void 0, n);
    }, this.onItemMouseOver = (n) => {
      this.mouseOverHandler.IsMouseOverEnabled && (this.clearItemHoverAndLeaveRequestsIfApplicable(), this.itemHoverRequest = window.setTimeout(
        () => {
          this.setHoveredItemId(n), this.itemHoverRequest = null;
        },
        hs(this.props)
      ));
    }, this.onItemMouseLeave = (n) => {
      this.mouseOverHandler.IsMouseOverEnabled && this.isItemWithDefaultClose(n) && (this.clearItemHoverAndLeaveRequestsIfApplicable(), this.itemLeaveRequest = window.setTimeout(
        () => {
          this.setHoveredItemId(X), this.itemLeaveRequest = null;
        },
        ps(this.props)
      ));
    }, this.onItemMouseDown = () => {
      this.mouseOverHandler.handleItemMouseDown();
    }, this.onItemFocus = (n) => {
      this.setFocusedItemId(n), this.mouseOverHandler.handleItemFocus();
    }, this.onItemClick = (n, i) => {
      const a = Re(i, this.items);
      a.disabled || (this.setFocusedItemId(i), this.mouseOverHandler.handleItemClick(i, this.isItemWithDefaultClose(i)), this.dispatchSelectEventIfWired(n, i), !n.isDefaultPrevented() && a.url && window.location.assign(a.url));
    }, this.onItemBlur = (n, i) => {
      if (this.isItemWithDefaultClose(n) && this.setFocusedItemId(X), i.relatedTarget && i.relatedTarget.nodeName === "LI") {
        const a = i.relatedTarget.getAttribute("id");
        if (a && a.includes(this.menuItemId))
          return;
      }
      this.props.onClose && this.props.onClose.call(void 0, i);
    }, this.getInputItem = (n) => Re(n, this.inputItems), W(K), this.mouseOverHandler = new Is(this.props.openOnClick, this.reset, this.onItemMouseOver), this.state = Object.assign({}, _t, { isFirstRender: !0 });
  }
  get menuItemId() {
    return this.props.id;
  }
  get element() {
    return this.menuWrapperEl;
  }
  /**
   * @hidden
   */
  render() {
    this.prepareItems(), this.state.isFirstRender || this.directionHolder.setIsDirectionRightToLeft(this.checkIsDirectionRightToLeft());
    let s = this.state.hoveredItemId ? this.state.hoveredItemId : this.state.focusedItemId ? pe(this.state.focusedItemId) : X;
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        id: this.props.id,
        onKeyDown: this.onKeyDown,
        style: this.props.style,
        className: this.directionHolder.getIsDirectionRightToLeft() ? "k-rtl" : void 0,
        ref: (n) => this.menuWrapperEl = n
      },
      /* @__PURE__ */ t.createElement(
        un,
        {
          className: this.getMenuClassName(),
          "aria-orientation": this.props.vertical ? "vertical" : void 0,
          items: this.items,
          isMenuVertical: this.props.vertical,
          isDirectionRightToLeft: this.directionHolder.getIsDirectionRightToLeft(),
          focusedItemId: this.state.focusedItemId,
          lastItemIdToBeOpened: s,
          tabbableItemId: this.state.tabbableItemId,
          itemRender: this.props.itemRender,
          linkRender: this.props.linkRender,
          menuGuid: this.menuItemId,
          onMouseLeave: this.onItemMouseLeave,
          onMouseOver: this.onItemMouseOver,
          onMouseDown: this.onItemMouseDown,
          onFocus: this.onItemFocus,
          onClick: this.onItemClick,
          onBlur: this.onItemBlur,
          onOriginalItemNeeded: this.getInputItem,
          role: this.props.role
        }
      )
    );
  }
  /**
   * @hidden
   */
  componentDidMount() {
    this.setState({ isFirstRender: !1 });
  }
  /**
   * @hidden
   */
  componentDidUpdate(s) {
    (!!s.vertical != !!this.props.vertical || this.directionHolder.hasDirectionChanged()) && this.reset(), this.mouseOverHandler.OpenOnClick = this.props.openOnClick;
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    this.clearItemHoverAndLeaveRequestsIfApplicable();
  }
  setFocusedItemId(s) {
    this.setState((n) => {
      const i = s === X ? n.tabbableItemId : ge(s);
      return { hoveredItemId: s === X || be(n.hoveredItemId) && be(s) ? n.hoveredItemId : X, focusedItemId: s, tabbableItemId: i };
    });
  }
  setHoveredItemId(s) {
    this.setState((n) => be(s) && be(n.focusedItemId) ? {
      hoveredItemId: s,
      focusedItemId: n.focusedItemId,
      tabbableItemId: n.tabbableItemId
    } : { hoveredItemId: s, focusedItemId: X, tabbableItemId: Be });
  }
  getMenuClassName() {
    return k(
      "k-reset",
      "k-header",
      "k-menu",
      { "k-menu-horizontal": !this.props.vertical },
      { "k-menu-vertical": this.props.vertical },
      this.props.className
    );
  }
  clearItemHoverAndLeaveRequestsIfApplicable() {
    this.itemHoverRequest && (clearTimeout(this.itemHoverRequest), this.itemHoverRequest = null), this.itemLeaveRequest && (clearTimeout(this.itemLeaveRequest), this.itemLeaveRequest = null);
  }
  isItemWithDefaultClose(s) {
    return !this.props.customCloseItemIds || this.props.customCloseItemIds.indexOf(s) === -1;
  }
  checkIsDirectionRightToLeft() {
    return !!(this.props.dir !== void 0 ? this.props.dir === "rtl" : this.menuWrapperEl && getComputedStyle(this.menuWrapperEl).direction === "rtl");
  }
  prepareItems() {
    const { items: s, inputItems: n } = cs(this.props.items, this.props.children);
    this.items = s, this.inputItems = n;
  }
  dispatchSelectEventIfWired(s, n) {
    q(this.props.onSelect, s, this, { item: this.getInputItem(n), itemId: n });
  }
};
He.propTypes = {
  vertical: r.bool,
  items: r.arrayOf(r.object),
  style: r.object,
  dir: r.string,
  hoverOpenDelay: r.number,
  hoverCloseDelay: r.number,
  openOnClick: r.bool,
  itemRender: r.any,
  linkRender: r.any,
  customCloseItemIds: r.arrayOf(r.string),
  onSelect: r.func,
  role: r.string
};
He.defaultProps = { vertical: !1 };
class mn extends t.Component {
  constructor() {
    super(...arguments), this.itemRef = null, this.focus = () => {
      this.itemRef && (this.itemRef.tabIndex = 0, this.itemRef.focus());
    }, this.blur = () => {
      this.itemRef && (this.itemRef.tabIndex = -1, this.itemRef.blur());
    }, this.onClick = () => {
      this.props.onSelect && this.props.onSelect(this.props.index), this.itemRef && (this.itemRef.tabIndex = 0, this.itemRef.focus());
    };
  }
  /**
   * @hidden
   */
  render() {
    const { id: s, active: n, disabled: i, title: a = "Untitled", first: o, last: l, contentPanelId: c, index: d } = this.props, u = {
      id: `${s}-${d.toString()}`,
      "aria-selected": n,
      "aria-controls": n ? c : void 0,
      "aria-disabled": i,
      role: "tab",
      onClick: i ? void 0 : this.onClick
    }, m = k("k-item", {
      ["k-first"]: o,
      ["k-last"]: l,
      ["k-disabled"]: i,
      ["k-active"]: n
    });
    return /* @__PURE__ */ t.createElement("li", { ...u, className: m, ref: (h) => this.itemRef = h, onBlur: this.blur }, /* @__PURE__ */ t.createElement("span", { className: "k-link" }, a));
  }
}
mn.propTypes = {
  active: r.bool,
  disabled: r.bool,
  index: r.number,
  onSelect: r.func,
  title: r.oneOfType([
    r.string,
    r.element
  ]),
  first: r.bool,
  last: r.bool
};
const Es = (e) => Array.apply(null, Array(e)), Cs = (e) => e.preventDefault(), Se = "smooth", le = "prev", xe = "next";
class tt extends t.Component {
  constructor(s) {
    super(s), this.itemsNavRef = t.createRef(), this.isRtl = () => this.props.dir === "rtl", this.onWheel = (n) => {
      n.stopPropagation();
      const i = n.deltaY < 0 ? le : xe;
      this.setNewScrollPosition(i, n);
    }, this.arrowClickPrev = (n) => {
      this.handleArrowClick(le, n);
    }, this.arrowClickNext = (n) => {
      this.handleArrowClick(xe, n);
    }, this.handleArrowClick = (n, i) => {
      this.setNewScrollPosition(n, i);
    }, this.setNewScrollPosition = (n, i) => {
      const a = this.itemsNavRef.current;
      if (!a)
        return;
      const o = this.horizontalScroll(), l = o ? a.scrollWidth - a.offsetWidth : a.scrollHeight - a.offsetHeight, c = (i.type === "click" ? this.props.buttonScrollSpeed : this.props.mouseScrollSpeed) || 0;
      let d = o ? a.scrollLeft : a.scrollTop, u = o ? a.scrollWidth - a.scrollLeft : a.scrollHeight - a.scrollTop, m = a.scrollWidth - a.scrollLeft * -1;
      this.isRtl() && this.horizontalScroll() ? (n === le && d < 0 && (d += c, m += c), n === xe && d < l && (d -= c, m -= c), d = Math.min(0, Math.min(l, d))) : (n === le && d > 0 && (d -= c, u += c), n === xe && d < l && (d += c, u -= c), d = Math.max(0, Math.min(l, d)));
      const h = d === 0, p = i.type === "click" ? Se : void 0;
      if (o) {
        const g = this.isRtl() ? Math.round(m) <= a.clientWidth || Math.floor(m) <= a.clientWidth : Math.round(u) <= a.clientWidth || Math.floor(u) <= a.clientWidth;
        this.setState({
          disabledPrev: h,
          disabledNext: g
        }), a.scrollTo({ left: d, behavior: p });
      } else
        this.setState({
          disabledPrev: h,
          disabledNext: Math.round(u) <= a.clientHeight || Math.floor(u) <= a.clientHeight
        }), a.scrollTo({ top: d, behavior: p });
    }, this.renderArrow = (n, i) => {
      const a = this.horizontalScroll(), o = {
        prev: {
          arrowTab: "k-tabstrip-prev",
          fontIcon: a ? this.isRtl() ? "caret-alt-right" : "caret-alt-left" : "caret-alt-up",
          svgIcon: a ? this.isRtl() ? oe : ae : Ye
        },
        next: {
          arrowTab: "k-tabstrip-next",
          fontIcon: a ? this.isRtl() ? "caret-alt-left" : "caret-alt-right" : "caret-alt-down",
          svgIcon: a ? this.isRtl() ? ae : oe : Ae
        }
      }, l = (n === le ? this.props.prevButton : this.props.nextButton) || Qn, c = n === le ? this.arrowClickPrev : this.arrowClickNext;
      return /* @__PURE__ */ t.createElement(
        l,
        {
          disabled: i,
          className: `${o[n].arrowTab}`,
          onClick: c,
          icon: o[n].fontIcon,
          svgIcon: o[n].svgIcon,
          onMouseDown: Cs,
          tabIndex: -1,
          fillMode: "flat"
        }
      );
    }, this.state = {
      disabledPrev: this.props.selected === 0,
      disabledNext: this.props.selected === t.Children.count(this.props.children) - 1
    };
  }
  /**
   * @hidden
   */
  componentDidMount() {
    this.props.scrollable && this.scrollToSelected();
  }
  /**
   * @hidden
   */
  componentDidUpdate(s) {
    const { scrollable: n, selected: i } = this.props;
    n && s.selected !== i && (this.scrollToSelected(), this.setState({
      disabledPrev: i === 0,
      disabledNext: i === t.Children.count(this.props.children) - 1
    }));
  }
  /**
   * @hidden
   */
  render() {
    const { selected: s, tabPosition: n, children: i, onSelect: a, onKeyDown: o, navItemId: l } = this.props, c = t.Children.count(i), d = t.Children.toArray(i);
    let u;
    i && (u = Es(c).map((p, g, b) => {
      const y = {
        active: s === g,
        disabled: d[g].props.disabled,
        index: g,
        title: d[g].props.title,
        first: g === 0,
        last: g === b.length - 1,
        contentPanelId: this.props.contentPanelId,
        id: l,
        onSelect: a
      };
      return /* @__PURE__ */ t.createElement(mn, { key: g, ...y });
    }));
    const m = k("k-tabstrip-items-wrapper", {
      "k-hstack": n === "top" || n === "bottom",
      "k-vstack": n === "left" || n === "right"
    }), h = k("k-tabstrip-items", "k-reset");
    return /* @__PURE__ */ t.createElement("div", { className: m }, this.props.scrollable ? /* @__PURE__ */ t.createElement(t.Fragment, null, this.renderArrow(le, this.state.disabledPrev), /* @__PURE__ */ t.createElement(
      "ul",
      {
        ref: this.itemsNavRef,
        className: h,
        role: "tablist",
        tabIndex: this.props.tabIndex,
        onKeyDown: o,
        onWheel: this.onWheel,
        "aria-orientation": n === "left" || n === "right" ? "vertical" : void 0
      },
      u
    ), this.renderArrow(xe, this.state.disabledNext)) : /* @__PURE__ */ t.createElement(
      "ul",
      {
        className: h,
        role: "tablist",
        tabIndex: this.props.tabIndex,
        onKeyDown: o
      },
      u
    ));
  }
  scrollToSelected() {
    const s = this.itemsNavRef.current, n = s && s.children[this.props.selected || 0];
    if (n instanceof HTMLElement && s instanceof HTMLElement) {
      const i = this.horizontalScroll(), a = i ? s.offsetWidth : s.offsetHeight, o = i ? n.offsetWidth : n.offsetHeight, l = i ? "left" : "top";
      let c = i ? s.scrollLeft : s.scrollTop, d = 0;
      if (this.isRtl()) {
        const u = n.offsetLeft;
        c = c * -1, u < 0 ? (d = u - o + s.offsetLeft, s.scrollTo({ [l]: d, behavior: Se })) : u + o > a - c && (d = c + u - o, s.scrollTo({ [l]: d, behavior: Se }));
      } else {
        const u = i ? n.offsetLeft - s.offsetLeft : n.offsetTop - s.offsetTop;
        c + a < u + o ? (d = u + o - a, s.scrollTo({ [l]: d, behavior: Se })) : c > u && (d = u, s.scrollTo({ [l]: d, behavior: Se }));
      }
    }
  }
  horizontalScroll() {
    return /top|bottom/.test(this.props.tabPosition || "top");
  }
}
tt.propTypes = {
  children: r.oneOfType([
    r.element,
    r.arrayOf(r.element)
  ]),
  onSelect: r.func,
  onKeyDown: r.func,
  selected: r.number,
  tabIndex: r.number
};
class hn extends t.Component {
  constructor() {
    super(...arguments), this.contentId = this.props.contentPanelId, this.childFactory = (s) => t.cloneElement(s, {
      ...s.props,
      in: s.props.children.props.id === String(this.contentId + this.props.selected)
    });
  }
  /**
   * @hidden
   */
  render() {
    const { children: s, selected: n, contentPanelId: i, keepTabsMounted: a, navItemId: o } = this.props, l = s && typeof n == "number" && t.Children.toArray(s)[n], c = k(
      "k-tabstrip-content",
      "k-active",
      l && l.props.contentClassName
    );
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        className: c,
        style: this.props.style,
        id: i,
        role: "tabpanel",
        "aria-hidden": a,
        "aria-describedby": `${o}-${(n || "").toString()}`
      },
      this.renderContent(s)
    );
  }
  renderContent(s) {
    return this.props.keepTabsMounted ? t.Children.map(this.props.children, (n, i) => this.renderChild(n, i)) : this.renderChild(
      t.Children.toArray(s)[this.props.selected],
      this.props.selected
    );
  }
  renderChild(s, n) {
    const i = n === this.props.selected, a = {
      style: {
        display: i ? void 0 : "none"
      }
    }, o = {
      position: "initial",
      display: i ? void 0 : "none"
    };
    return s.props.disabled ? null : this.props.animation ? /* @__PURE__ */ t.createElement(
      es,
      {
        appear: !0,
        exit: this.props.keepTabsMounted,
        style: o,
        childFactory: this.props.keepTabsMounted ? this.childFactory : void 0
      },
      /* @__PURE__ */ t.createElement("div", { ...a, id: String(this.contentId + n), key: n }, s.props.children)
    ) : /* @__PURE__ */ t.createElement("div", { ...a, key: n }, s.props.children);
  }
}
hn.propTypes = {
  animation: r.bool,
  children: r.oneOfType([
    r.element,
    r.arrayOf(r.element)
  ]),
  selected: r.number,
  style: r.object
};
let dt = class extends t.Component {
  constructor(s) {
    super(s), this._element = null, this.showLicenseWatermark = !1, this.keyBinding = {
      [C.left]: () => this.prevNavigatableTab(),
      [C.right]: () => this.nextNavigatableTab(),
      [C.down]: () => this.nextNavigatableTab(),
      [C.up]: () => this.prevNavigatableTab(),
      [C.home]: () => 0,
      [C.end]: () => t.Children.count(this.props.children) - 1
    }, this.onSelect = (n) => {
      this.props.selected !== n && this.props.onSelect && this.props.onSelect({
        selected: n
      });
    }, this.onKeyDown = (n) => {
      let i;
      switch (n.keyCode) {
        case C.left:
          i = this.keyBinding[this.invertKeys(C.left, C.right)];
          break;
        case C.right:
          i = this.keyBinding[this.invertKeys(C.right, C.left)];
          break;
        case C.up:
          i = this.keyBinding[C.up];
          break;
        case C.down:
          i = this.keyBinding[C.down];
          break;
        case C.home:
          i = this.keyBinding[C.home];
          break;
        case C.end:
          i = this.keyBinding[C.end];
          break;
      }
      i && (n.preventDefault(), this.onSelect(i()));
    }, this.renderContent = (n) => {
      const { selected: i, children: a, tabContentStyle: o } = n, l = t.Children.count(a);
      return i < l && i > -1 ? /* @__PURE__ */ t.createElement(hn, { index: i, ...n, style: o }) : null;
    }, this.firstNavigatableTab = () => {
      const n = this.children(), i = t.Children.count(n);
      if (n) {
        for (let a = 0; a < i; a++)
          if (!n[a].props.disabled)
            return a;
      }
    }, this.lastNavigatableTab = () => {
      const n = this.children(), i = t.Children.count(n);
      if (n) {
        for (let a = i - 1; a > 0; a--)
          if (!n[a].props.disabled)
            return a;
      }
    }, this.prevNavigatableTab = () => {
      const n = this.children(), { selected: i } = this.props, a = i ? i - 1 : -1;
      if (a < 0)
        return this.lastNavigatableTab();
      if (n)
        for (let o = a; o > -1; o--) {
          if (!n[o].props.disabled)
            return o;
          if (o === 0)
            return this.lastNavigatableTab();
        }
    }, this.nextNavigatableTab = () => {
      const n = this.children(), { selected: i } = this.props, a = i ? i + 1 : 1, o = t.Children.count(n);
      if (a >= o)
        return this.firstNavigatableTab();
      if (n)
        for (let l = a; l < o; l++) {
          if (!n[l].props.disabled)
            return l;
          if (l + 1 === o)
            return this.firstNavigatableTab();
        }
    }, W(K), this.showLicenseWatermark = ze(K);
  }
  get contentPanelId() {
    return this.props.id + "-content-panel-id";
  }
  get navItemId() {
    return this.props.id + "-nav-item-id";
  }
  /**
   * @hidden
   */
  render() {
    const s = {
      ...this.props,
      children: this.children(),
      contentPanelId: this.contentPanelId,
      navItemId: this.navItemId,
      onKeyDown: this.onKeyDown,
      onSelect: this.onSelect
    }, { tabPosition: n, tabIndex: i = 0 } = s, a = n === "bottom", o = k(
      "k-tabstrip k-pos-relative",
      {
        "k-tabstrip-left": n === "left",
        "k-tabstrip-right": n === "right",
        "k-tabstrip-bottom": n === "bottom",
        "k-tabstrip-top": n === "top",
        "k-tabstrip-scrollable": this.props.scrollable
      },
      this.props.className
    );
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        id: this.props.id,
        ref: (l) => this._element = l,
        dir: this.props.dir,
        className: o,
        style: this.props.style
      },
      !a && /* @__PURE__ */ t.createElement(tt, { ...s, tabIndex: i }),
      this.renderContent(s),
      a && /* @__PURE__ */ t.createElement(tt, { ...s, tabIndex: i }),
      this.showLicenseWatermark && /* @__PURE__ */ t.createElement(Fe, null)
    );
  }
  invertKeys(s, n) {
    return this._element && getComputedStyle(this._element).direction === "rtl" || !1 ? n : s;
  }
  children() {
    return t.Children.toArray(this.props.children).filter((s) => s);
  }
};
dt.propTypes = {
  animation: r.bool,
  children: r.node,
  onSelect: r.func,
  selected: r.number,
  style: r.object,
  tabContentStyle: r.object,
  tabPosition: r.string,
  tabIndex: r.number,
  className: r.string,
  dir: r.string
};
dt.defaultProps = {
  animation: !0,
  tabPosition: "top",
  keepTabsMounted: !1,
  buttonScrollSpeed: 100,
  mouseScrollSpeed: 10
};
class Ns extends t.Component {
  constructor(s) {
    super(s), this.draggable = null, this.onDrag = (n, i, a) => {
      const { event: o } = n, { onDrag: l, index: c } = this.props, d = this.draggable && this.draggable.element;
      d && !this.isStatic && this.isDraggable && l(o, d, c, i, a);
    }, this.onFocus = () => {
      this.setState({
        focused: !0
      });
    }, this.onBlur = () => {
      this.setState({
        focused: !1
      });
    }, this.onToggle = (n) => {
      const { onToggle: i, index: a, prev: o, next: l } = this.props;
      (o.collapsible || l.collapsible) && i(o.collapsible ? a : a + 1, n);
    }, this.onPrevToggle = (n) => {
      const { onToggle: i, index: a, prev: o } = this.props;
      o.collapsible && i(a, n);
    }, this.onNextToggle = (n) => {
      const { onToggle: i, index: a, next: o } = this.props;
      o.collapsible && i(a + 1, n);
    }, this.onKeyDown = (n) => {
      const i = n && n.keyCode, a = this.isHorizontal, { index: o } = this.props, l = this.draggable && this.draggable.element, c = (d, u, m) => {
        n.preventDefault(), this.props.onKeyboardResize(d, u, m, n);
      };
      l && (i === C.enter ? (n.preventDefault(), this.onToggle(n)) : this.isDraggable && (a && i === C.left ? c(l, o, -10) : a && i === C.right ? c(l, o, 10) : !a && i === C.up ? c(l, o, -10) : !a && i === C.down && c(l, o, 10)));
    }, this.state = {
      focused: !1
    };
  }
  get isStatic() {
    const { prev: s, next: n } = this.props, i = s.resizable && n.resizable, a = s.collapsible || n.collapsible;
    return !i && !a;
  }
  get isDraggable() {
    const { prev: s, next: n } = this.props, i = s.resizable && n.resizable, a = s.collapsed || n.collapsed;
    return !!i && !a;
  }
  get isHorizontal() {
    return this.props.orientation === "horizontal";
  }
  render() {
    const s = this.isDraggable, n = this.isStatic, i = this.isHorizontal, a = k(
      "k-splitbar",
      {
        ["k-focus"]: this.state.focused,
        ["k-splitbar-horizontal"]: i,
        ["k-splitbar-vertical"]: !i,
        ["k-splitbar-draggable-horizontal"]: i && s,
        ["k-splitbar-draggable-vertical"]: !i && s,
        ["k-splitbar-static-horizontal"]: i && n,
        ["k-splitbar-static-vertical"]: !i && n
      }
    );
    return /* @__PURE__ */ t.createElement(
      lt,
      {
        onPress: (o) => this.onDrag(o, !0, !1),
        onDrag: (o) => this.onDrag(o, !1, !1),
        onRelease: (o) => this.onDrag(o, !1, !0),
        ref: (o) => {
          this.draggable = o;
        }
      },
      /* @__PURE__ */ t.createElement(
        "div",
        {
          tabIndex: n ? -1 : 0,
          role: "separator",
          "aria-valuenow": 0,
          "aria-label": this.props.ariaLabel,
          "aria-orientation": i ? "vertical" : void 0,
          className: a,
          style: { touchAction: "none" },
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onDoubleClick: this.onToggle,
          onKeyDown: this.onKeyDown
        },
        this.props.prev.collapsible && /* @__PURE__ */ t.createElement(
          "div",
          {
            className: "k-collapse-prev",
            onClick: this.onPrevToggle
          },
          /* @__PURE__ */ t.createElement(
            Q,
            {
              name: this.props.prev.collapsible ? i ? this.props.prev.collapsed ? this.props.isRtl ? "caret-alt-left" : "caret-alt-right" : this.props.isRtl ? "caret-alt-right" : "caret-alt-left" : this.props.prev.collapsed ? "caret-alt-down" : "caret-alt-up" : void 0,
              icon: this.props.prev.collapsible ? i ? this.props.prev.collapsed ? this.props.isRtl ? ae : oe : this.props.isRtl ? oe : ae : this.props.prev.collapsed ? Ae : Ye : void 0,
              size: "xsmall"
            }
          )
        ),
        /* @__PURE__ */ t.createElement("div", { className: "k-resize-handle" }),
        this.props.next.collapsible && /* @__PURE__ */ t.createElement(
          "div",
          {
            className: "k-collapse-next",
            onClick: this.onNextToggle
          },
          /* @__PURE__ */ t.createElement(
            Q,
            {
              name: this.props.next.collapsible ? i ? this.props.next.collapsed ? this.props.isRtl ? "caret-alt-right" : "caret-alt-left" : this.props.isRtl ? "caret-alt-left" : "caret-alt-right" : this.props.next.collapsed ? "caret-alt-up" : "caret-alt-down" : void 0,
              icon: this.props.next.collapsible ? i ? this.props.next.collapsed ? this.props.isRtl ? oe : ae : this.props.isRtl ? ae : oe : this.props.next.collapsed ? Ye : Ae : void 0,
              size: "xsmall"
            }
          )
        )
      )
    );
  }
}
class ws extends t.Component {
  /**
   * @hidden
   */
  render() {
    return null;
  }
}
ws.propTypes = {
  disabled: r.bool,
  contentClassName: r.string,
  children: r.oneOfType([
    r.element,
    r.node
  ]),
  title: r.oneOfType([
    r.string,
    r.element,
    r.node
  ])
};
function Ss({ imageUrl: e, icon: s, svgIcon: n, iconClass: i }) {
  return e ? /* @__PURE__ */ t.createElement("img", { role: "presentation", className: "k-panelbar-item-icon k-image", src: e }) : s || n ? /* @__PURE__ */ t.createElement(Q, { className: "k-panelbar-item-icon", name: s, icon: n }) : i ? /* @__PURE__ */ t.createElement("span", { role: "presentation", className: "k-panelbar-item-icon " + i }) : null;
}
class ce extends t.PureComponent {
  constructor(s) {
    super(s), this.handleItemClick = () => {
      const { onSelect: n, disabled: i, id: a } = this.props;
      n && !i && n.call(void 0, {
        uniquePrivateKey: this.props.uniquePrivateKey,
        id: a,
        target: this
      });
    }, this.childFactory = (n) => this.props.keepItemsMounted ? t.cloneElement(n, {
      ...n.props,
      in: this.props.expanded
    }) : n, this.state = {
      show: s.expanded || !1
    };
  }
  /**
   * @hidden
   */
  render() {
    const {
      id: s,
      children: n,
      title: i,
      uniquePrivateKey: a,
      disabled: o,
      selected: l,
      focused: c,
      expanded: d,
      className: u,
      level: m,
      headerClassName: h,
      animation: p,
      keepItemsMounted: g
    } = this.props, b = {
      role: "treeitem",
      "aria-disabled": o,
      "aria-hidden": !o && !d,
      "aria-selected": !o && l,
      "aria-expanded": !o && d && !!n
    }, y = k(
      "k-panelbar-item",
      {
        "k-panelbar-header": m === 0,
        "k-expanded": d && !!n,
        "k-disabled": o
      },
      `k-level-${m}`,
      u
    ), E = k(
      "k-link",
      {
        "k-selected": !o && l,
        "k-focus": !o && c
      },
      h
    ), N = { display: "block" }, f = Ss(this.props), R = !o && n ? /* @__PURE__ */ t.createElement(
      Q,
      {
        name: d ? "chevron-up" : "chevron-down",
        icon: d ? Yt : Zt,
        className: k(
          "k-panelbar-toggle",
          d ? "k-panelbar-collapse" : "k-panelbar-expand"
        )
      }
    ) : null, w = !o && d || g ? /* @__PURE__ */ t.createElement(
      "ul",
      {
        role: "group",
        "aria-expanded": d,
        "aria-hidden": !d,
        className: "k-panelbar-group k-panel k-group",
        style: { display: g ? this.state.show ? "block" : "none" : "block" }
      },
      n
    ) : null, S = (p === void 0 || p) && !o && n ? /* @__PURE__ */ t.createElement(
      Qt,
      {
        transitionEnterDuration: 200,
        transitionExitDuration: 200,
        key: a + "_animation",
        style: N,
        children: w,
        childFactory: g && this.childFactory,
        unmountOnExit: !g,
        onBeforeEnter: () => g && this.setState({ show: !0 }),
        onAfterExited: () => g && this.setState({ show: !1 })
      }
    ) : w;
    return /* @__PURE__ */ t.createElement(
      "li",
      {
        id: s,
        className: y,
        ...b
      },
      /* @__PURE__ */ t.createElement("span", { className: E, onClick: this.handleItemClick }, f, /* @__PURE__ */ t.createElement("span", { className: "k-panelbar-item-text" }, i), R),
      S
    );
  }
}
ce.propTypes = {
  animation: r.bool,
  children: r.any,
  className: r.string,
  icon: r.string,
  iconClass: r.string,
  imageUrl: r.string,
  svgIcon: De,
  expanded: r.bool,
  disabled: r.bool,
  onSelect: r.func,
  selected: r.bool,
  level: r.number,
  title: r.oneOfType([
    r.string,
    r.element
  ]),
  id: r.oneOfType([
    r.string,
    r.number
  ]),
  focused: r.bool,
  keepItemsMounted: r.bool
};
ce.defaultProps = {
  title: "Untitled"
};
const pn = ({
  animation: e = !0,
  keepItemsMounted: s = !1,
  state: n,
  expanded: i,
  handleSelect: a,
  children: o,
  parentExpanded: l = !0,
  level: c = 0,
  parentPrivateKey: d = []
}) => t.Children.map(o, (u, m) => {
  if (u && u.type === ce) {
    let h, p = ut(u, d, m);
    if (u.props.children) {
      const g = {
        animation: e,
        keepItemsMounted: s,
        state: n,
        expanded: i,
        handleSelect: a,
        children: u.props.children,
        parentExpanded: (i || []).indexOf(p) > -1,
        level: c + 1,
        parentPrivateKey: [...d, p]
      };
      h = pn(g);
    }
    return t.cloneElement(
      u,
      {
        ...u.props,
        animation: u.props.animation !== void 0 ? u.props.animation : e,
        keepItemsMounted: s,
        id: u.props.id || `k-panelbar-item-default-${p}`,
        uniquePrivateKey: p,
        parentUniquePrivateKey: d,
        parentExpanded: l,
        level: c,
        expanded: (i || []).indexOf(p) > -1,
        focused: n.focused === p && n.wrapperFocused,
        selected: n.selected === p,
        children: h,
        onSelect: a
      }
    );
  } else
    return /* @__PURE__ */ t.createElement("div", { className: "k-panelbar-content k-content" }, u);
}), xs = (e) => {
  const s = t.Children.toArray(e.children)[0];
  return s ? ut(s, [], 0) : "";
}, fn = (e, s, n = {
  expanded: e.expanded || [],
  selected: e.selected || "",
  focused: e.focused || "",
  wrapperFocused: !1
}, i = !0, a = []) => (t.Children.map(e.children, (o, l) => {
  if (o && o.type === ce) {
    let c = ut(o, a, l);
    !o.props.disabled && i && (o.props.selected && (n.selected = c), o.props.focused && (n.focused = c), o.props.expanded && (s === "multiple" ? n.expanded.push(c) : s === "single" && (n.expanded = [c])), o.props.children && (n = fn(
      o.props,
      s,
      n,
      !!o.props.expanded,
      [...a, c]
    )));
  }
}), n), ut = (e, s, n) => e && e.props && e.props.id ? e.props.id : s.length ? s[s.length - 1] + `.${n}` : `.${n}`;
function Ts(e, s = []) {
  return (e || []).forEach((n) => {
    n.disabled || (s.push(n), n.expanded && n.children && Ts(n.children, s));
  }), s;
}
function gn(e, s = []) {
  return t.Children.forEach(e, (n) => {
    n && n.props && !n.props.disabled && (s.push(n), n.props.children && gn(n.props.children, s));
  }), s;
}
function bn(e, s = []) {
  return t.Children.forEach(e, (n) => {
    n && n.props && !n.props.disabled && (n.props.expanded || n.props.parentExpanded) && (s.push(n), n.props.children && bn(n.props.children, s));
  }), s;
}
const pi = (e) => e != null;
var Wt;
((e) => {
  function s(n) {
    return n.map((i, a) => {
      let o;
      return i.content && (o = i.content), i.children && (o = s(i.children)), /* @__PURE__ */ t.createElement(
        ce,
        {
          ...i,
          children: o,
          key: i.id || a
        }
      );
    });
  }
  e.mapItemsToComponents = s;
})(Wt || (Wt = {}));
const Rs = (e, s) => e.length !== s.length ? !1 : e.every((n, i) => n === s[i]);
var te = /* @__PURE__ */ ((e) => (e[e.Toggle = 0] = "Toggle", e[e.Next = 1] = "Next", e[e.Previous = 2] = "Previous", e))(te || {});
class vn extends t.Component {
  constructor(s) {
    super(s), this._element = null, this.showLicenseWatermark = !1, this.handleSelect = (i) => {
      this.onSelect(i), this.onFocus(i);
    }, this.onSelect = (i) => {
      const a = gn(t.Children.toArray(this.children));
      let o, l;
      switch (a.forEach((c) => {
        c.props.uniquePrivateKey === (i.uniquePrivateKey || this.state.focused) && (o = c);
      }), this.expandMode) {
        case "single":
          l = [...o.props.parentUniquePrivateKey, o.props.uniquePrivateKey], Rs(this.expandedItems, l) && (o.props.parentUniquePrivateKey ? l = [...o.props.parentUniquePrivateKey] : l = []);
          break;
        case "multiple": {
          l = this.expandedItems.slice();
          let c = l.indexOf(o.props.uniquePrivateKey);
          c === -1 ? l.push(o.props.uniquePrivateKey) : l.splice(c, 1);
          break;
        }
        default:
          l = this.expandedItems.slice();
          break;
      }
      this.setState({ selected: o.props.uniquePrivateKey, expanded: l }), this.props.onSelect && this.props.onSelect.call(void 0, {
        target: o,
        expandedItems: l
      });
    }, this.onFocus = (i, a = 0) => {
      const o = bn(t.Children.toArray(this.children));
      let l;
      o.forEach((c, d) => {
        if (c.props.uniquePrivateKey === (i.uniquePrivateKey || this.state.focused)) {
          let u = d + a < 0 ? 0 : d + a > o.length ? o.length - 1 : d + a;
          l = o[u];
        }
      }), l && (this.activeDescendant = l.props.id, this.setState({ focused: l.props.uniquePrivateKey }));
    }, this.onNavigate = (i, a) => {
      let o;
      switch (a) {
        case te.Previous:
          o = -1, this.onFocus(i, o);
          break;
        case te.Next:
          o = 1, this.onFocus(i, o);
          break;
        case te.Toggle:
          this.onSelect(i);
          break;
      }
    }, this.handleWrapperFocus = () => {
      clearTimeout(this.nextTickId), this.state.wrapperFocused || this.setState({ wrapperFocused: !0 });
    }, this.handleWrapperBlur = () => {
      this.nextTick(() => {
        this.setState({ wrapperFocused: !1 });
      });
    }, this.handleKeyDown = (i) => {
      const a = this._element && getComputedStyle(this._element).direction === "rtl" || !1;
      if (i.target === i.currentTarget) {
        const o = i.keyCode;
        let l;
        switch (o) {
          case C.left:
            l = a ? te.Next : te.Previous;
            break;
          case C.up:
            l = te.Previous;
            break;
          case C.right:
            l = a ? te.Previous : te.Next;
            break;
          case C.down:
            l = te.Next;
            break;
          case C.space:
          case C.enter:
            l = te.Toggle;
            break;
          default:
            l = null;
            break;
        }
        l !== null && (i.preventDefault(), this.onNavigate(i, l));
      }
    }, W(K), this.showLicenseWatermark = ze(K);
    const n = fn(s, this.expandMode);
    n.focused || (n.focused = xs(s)), this.state = n;
  }
  get expandMode() {
    return this.props.expandMode || "multiple";
  }
  get selectedItem() {
    const { selected: s = this.state.selected } = this.props;
    return s;
  }
  get expandedItems() {
    return this.props.isControlled ? this.props.expanded || [] : this.state.expanded;
  }
  get children() {
    const s = { ...this.state, selected: this.selectedItem }, n = {
      animation: this.props.animation,
      keepItemsMounted: this.props.keepItemsMounted,
      state: s,
      expanded: this.expandedItems,
      handleSelect: this.handleSelect,
      children: this.props.children
    };
    return pn(n);
  }
  /**
   * @hidden
   */
  render() {
    const s = {
      "aria-activedescendant": this.activeDescendant
    }, n = k(
      "k-panelbar",
      "k-pos-relative",
      this.props.className
    );
    return /* @__PURE__ */ t.createElement(
      "ul",
      {
        ref: (i) => {
          this._element = i;
        },
        dir: this.props.dir,
        role: "tree",
        tabIndex: 0,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleWrapperFocus,
        onBlur: this.handleWrapperBlur,
        className: n,
        style: this.props.style,
        ...s
      },
      this.children,
      this.showLicenseWatermark && /* @__PURE__ */ t.createElement(Fe, null)
    );
  }
  nextTick(s) {
    this.nextTickId = window.setTimeout(() => s());
  }
}
vn.propTypes = {
  animation: r.bool,
  children: function(e, s) {
    const n = e[s];
    if (n) {
      if (Array.isArray(n)) {
        for (let i of n)
          if (!i.type || i.type !== ce)
            return new Error(
              "PanelBar children should be either PanelBarItem or Array of PanelBarItem."
            );
      } else if (n.type !== ce)
        return new Error(
          "PanelBar child should be either PanelBarItem or Array of PanelBarItem."
        );
      return null;
    }
    return null;
  },
  dir: r.string,
  selected: r.string,
  expanded: r.arrayOf(r.string),
  focused: r.string,
  expandMode: r.oneOf(["single", "multiple"]),
  className: r.string,
  keepItemsMounted: r.bool,
  onSelect: r.func,
  style: r.object
};
vn.defaultProps = {
  expandMode: "multiple",
  animation: !0,
  keepItemsMounted: !1
};
class Ds extends t.Component {
  render() {
    const {
      id: s,
      size: n,
      collapsed: i,
      overlay: a,
      containsSplitter: o,
      collapsible: l,
      resizable: c,
      scrollable: d,
      keepMounted: u
    } = this.props, m = n && n.length > 0, h = {
      flexBasis: n
    }, p = k(
      "k-pane",
      {
        ["k-hidden"]: i,
        hidden: i,
        ["k-pane-flex"]: o,
        ["k-pane-static"]: !c && !l || m,
        ["k-scrollable"]: d
      }
    );
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        id: s,
        role: "group",
        style: h,
        className: p
      },
      !i || u ? this.props.children : void 0,
      a ? /* @__PURE__ */ t.createElement("div", { className: "k-splitter-overlay k-overlay" }) : void 0
    );
  }
}
const nt = "splitBarLabel", Os = {
  [nt]: "split bar"
}, Ps = {
  collapsible: !1,
  collapsed: !1,
  resizable: !0,
  scrollable: !0
}, Ms = 150;
class Ls extends t.Component {
  /**
   * @hidden
   */
  constructor(s) {
    super(s), this._container = null, this.validatePanes = (n) => {
      if (!n.filter((a) => a.size === void 0).length)
        throw new Error("The Splitter should have at least one pane without a set size.");
    }, this.mapPaneOptions = (n, i) => {
      const a = this.orientation, { dragIndex: o, isDragging: l } = this.state, c = [];
      for (let d = 0; d < i.length; d++) {
        let u = !1;
        const m = i[d];
        t.isValidElement(m) && (u = m.type.displayName === "Splitter");
        let h = !1;
        l && o !== void 0 && (h = o === d || o + 1 === d), c.push({
          ...Ps,
          orientation: a,
          containsSplitter: u,
          overlay: h,
          ...(n || [])[d]
        });
      }
      return c;
    }, this.mapSplitterPanes = (n, i) => {
      const a = ns(this).toLanguageString(nt, Os[nt]);
      return n.map((o, l) => {
        let c;
        const d = l * 2, u = d + 1;
        if (l + 1 < n.length) {
          const h = n[l + 1];
          c = /* @__PURE__ */ t.createElement(
            Ns,
            {
              key: u,
              index: l,
              orientation: o.orientation,
              prev: o,
              next: h,
              ariaLabel: a,
              onDrag: this.onBarDragResize,
              onToggle: this.onBarToggle,
              onKeyboardResize: this.onBarKeyboardResize,
              isRtl: this.isRtl
            }
          );
        }
        return [/* @__PURE__ */ t.createElement(
          Ds,
          {
            key: d,
            ...o
          },
          i[l]
        ), c];
      });
    }, this.onBarToggle = (n, i) => {
      const o = this.panesOptions(this.panesContent).map((l, c) => {
        const d = this.getPaneProps(l);
        return c === n ? {
          ...d,
          collapsed: !l.collapsed
        } : {
          ...d
        };
      });
      this.props.onChange && this.props.onChange({
        newState: o,
        isLast: !0,
        nativeEvent: i
      });
    }, this.onBarDragResize = (n, i, a, o, l) => {
      const c = (/* @__PURE__ */ new Date()).getTime(), { pageX: d, pageY: u } = n, { prevElement: m, nextElement: h } = this.surroudingPanes(i);
      if (!m || !h)
        return;
      if (o) {
        this.setState({
          isDragging: !0,
          dragIndex: a,
          startTime: c,
          originalX: d,
          originalY: u,
          originalPrevSize: this.elementSize(m),
          originalNextSize: this.elementSize(h)
        });
        return;
      }
      const { originalPrevSize: p, originalNextSize: g, startTime: b, originalX: y, originalY: E } = this.state;
      if (!o && c - b < Ms) {
        l && this.resetDragState();
        return;
      }
      let N;
      this.orientation === "vertical" ? N = u - E : this.isRtl ? N = y - d : N = d - y, this.resize(a, a + 1, p, g, N, l, n), l && this.resetDragState();
    }, this.onBarKeyboardResize = (n, i, a, o) => {
      const { prevElement: l, nextElement: c } = this.surroudingPanes(n), d = this.elementSize(l), u = this.elementSize(c);
      this.resize(i, i + 1, d, u, a, !0, o);
    }, this.containerSize = () => this._container ? this.elementSize(this._container, !0) : 0, this.panesOptions = (n) => this.mapPaneOptions(this.panes, n), this.elementSize = (n, i) => {
      const a = i ? "client" : "offset";
      return this.orientation === "vertical" ? n[`${a}Height`] : n[`${a}Width`];
    }, this.clamp = (n, i, a) => Math.min(i, Math.max(n, a)), this.fixedSize = (n) => n && n.length > 0, W(K), this.state = {
      isDragging: !1,
      dragIndex: void 0,
      startTime: 0,
      originalX: 0,
      originalY: 0,
      originalPrevSize: 0,
      originalNextSize: 0,
      panes: s.defaultPanes || []
    };
  }
  get isControlledState() {
    return this.props.panes !== void 0;
  }
  get panes() {
    return this.panesDuringOnChange !== void 0 ? this.panesDuringOnChange : this.isControlledState ? this.props.panes : this.state.panes;
  }
  get orientation() {
    return this.props.orientation || "horizontal";
  }
  get isRtl() {
    return this._container && getComputedStyle(this._container).direction === "rtl" || !1;
  }
  get panesContent() {
    return t.Children.toArray(this.props.children).filter((s) => s);
  }
  /**
   * @hidden
   */
  render() {
    const s = this.panesContent, n = this.panesOptions(s), i = k(
      "k-widget",
      "k-splitter",
      "k-splitter-flex",
      `k-splitter-${this.orientation}`,
      this.props.className
    );
    return this.validatePanes(n), /* @__PURE__ */ t.createElement(
      "div",
      {
        style: this.props.style,
        ref: (a) => this._container = a,
        className: i
      },
      this.mapSplitterPanes(n, s)
    );
  }
  surroudingPanes(s) {
    return {
      prevElement: s.previousElementSibling,
      nextElement: s.nextElementSibling
    };
  }
  isPercent(s) {
    return /%$/.test(s);
  }
  toPixels(s, n) {
    let i = parseInt(s, 10);
    return this.isPercent(s) && (i = n * i / 100), i;
  }
  resetDragState() {
    this.setState({
      isDragging: !1,
      dragIndex: void 0,
      startTime: 0,
      originalX: 0,
      originalY: 0,
      originalPrevSize: 0,
      originalNextSize: 0
    });
  }
  resize(s, n, i, a, o, l, c) {
    const d = this.panesOptions(this.panesContent), u = d[s], m = d[n], h = i + a, p = this.containerSize(), g = (v) => this.toPixels(v, p), b = {
      index: s,
      initialSize: i,
      min: g(u.min) || h - g(m.max) || 0,
      max: g(u.max) || h - g(m.min) || h
    }, y = {
      index: n,
      initialSize: a,
      min: g(m.min) || h - g(u.max) || 0,
      max: g(m.max) || h - g(u.min) || h
    }, E = (v, w) => {
      const S = d[v.index], O = this.clamp(v.min, v.max, v.initialSize + w);
      return this.isPercent(S.size || "") ? 100 * O / p + "%" : O + "px";
    };
    let N, f;
    this.fixedSize(u.size) && this.fixedSize(m.size) ? (N = E(b, o), f = E(y, -o)) : m.collapsible || this.fixedSize(m.size) ? f = E(y, -o) : N = E(b, o);
    const R = d.map((v, w) => {
      const S = this.getPaneProps(v);
      return w === s ? {
        ...S,
        size: N
      } : w === n ? {
        ...S,
        size: f
      } : {
        ...S
      };
    });
    this.panesDuringOnChange = R, this.isControlledState || this.setState({
      panes: R
    }), this.props.onChange && this.props.onChange({
      newState: R,
      isLast: l,
      nativeEvent: c
    }), this.panesDuringOnChange = void 0;
  }
  getPaneProps(s) {
    const { orientation: n, overlay: i, containsSplitter: a, ...o } = s;
    return o;
  }
}
Ls.displayName = "Splitter";
var kn = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.IMAGE = "image", e.ICON = "icon", e))(kn || {}), Pe = /* @__PURE__ */ ((e) => (e.HORIZONTAL = "horizontal", e.VERTICAL = "vertical", e))(Pe || {}), mt = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.primary = "primary", e.INFO = "info", e.SUCCESS = "success", e.WARNING = "warning", e.ERROR = "error", e))(mt || {}), yn = /* @__PURE__ */ ((e) => (e.START = "start", e.CENTER = "center", e.END = "end", e.STRETCHED = "stretched", e))(yn || {});
const _e = t.forwardRef((e, s) => {
  W(K);
  const { children: n, dir: i, style: a, className: o, type: l, orientation: c, ...d } = e, u = t.useRef(null), m = t.useRef(null);
  return t.useImperativeHandle(u, () => ({
    element: m.current,
    props: e
  })), t.useImperativeHandle(s, () => u.current), /* @__PURE__ */ t.createElement(
    "div",
    {
      dir: i,
      style: a,
      ref: m,
      className: k(
        "k-card",
        o,
        { [`k-card-${l}`]: l !== mt.DEFAULT },
        c !== Pe.HORIZONTAL ? "k-card-vertical" : "k-card-horizontal"
      ),
      ...d
    },
    n
  );
});
_e.displayName = "KendoReactCard";
_e.propTypes = {
  children: r.node,
  className: r.string,
  dir: r.string,
  orientation: r.oneOf(["horizontal", "vertical"]),
  style: r.object,
  type: r.oneOf(["default", "primary", "info", "success", "warning", "error"])
};
_e.defaultProps = {
  type: mt.DEFAULT,
  orientation: Pe.VERTICAL
};
const In = (e) => /* @__PURE__ */ t.createElement(
  "div",
  {
    style: e.style,
    className: k(
      "k-card-header",
      e.className
    )
  },
  e.children
);
In.propTypes = {
  className: r.string
};
const En = (e) => /* @__PURE__ */ t.createElement(
  "div",
  {
    style: e.style,
    className: k(
      "k-card-title",
      e.className
    )
  },
  e.children
);
En.propTypes = {
  className: r.string
};
const Cn = (e) => /* @__PURE__ */ t.createElement(
  "div",
  {
    style: e.style,
    className: k(
      "k-card-body",
      e.className
    )
  },
  e.children
);
Cn.propTypes = {
  className: r.string
};
const Nn = (e) => {
  const s = {
    layout: yn.START,
    orientation: Pe.HORIZONTAL,
    ...e
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      style: s.style,
      className: k(
        "k-card-actions",
        s.className,
        `k-card-actions-${s.layout}`,
        s.orientation !== Pe.VERTICAL ? "k-card-actions-horizontal" : "k-card-actions-vertical"
      )
    },
    s.children
  );
};
Nn.propTypes = {
  layout: r.oneOf(["stretched", "start", "center", "end"]),
  orientation: r.oneOf(["horizontal", "vertical"])
};
const wn = (e) => {
  const s = {
    src: "",
    ...e
  };
  return /* @__PURE__ */ t.createElement(
    "img",
    {
      style: s.style,
      className: k(
        "k-card-image",
        s.className
      ),
      src: s.src,
      alt: s.alt
    }
  );
};
wn.propTypes = {
  className: r.string,
  src: r.string
};
const Sn = (e) => /* @__PURE__ */ t.createElement(
  "div",
  {
    style: e.style,
    className: k(
      "k-card-subtitle",
      e.className
    )
  },
  e.children
);
Sn.propTypes = {
  className: r.string
};
const As = (e) => /* @__PURE__ */ t.createElement(
  "div",
  {
    style: e.style,
    className: k(
      "k-card-footer",
      e.className
    )
  },
  e.children
);
As.propTypes = {
  className: r.string
};
const zs = (e) => {
  const s = {
    type: kn.TEXT,
    size: "medium",
    rounded: "full",
    fillMode: "solid",
    themeColor: "primary",
    ...e
  };
  return W(K), /* @__PURE__ */ t.createElement(
    "div",
    {
      style: s.style,
      className: k(
        "k-avatar",
        {
          ["k-avatar-bordered"]: s.border,
          [`k-rounded-${Ge.roundedMap[s.rounded] || s.rounded}`]: s.rounded,
          [`k-avatar-${Ge.sizeMap[s.size] || s.size}`]: s.size,
          [`k-avatar-${s.fillMode}`]: s.fillMode,
          [`k-avatar-${s.fillMode}-${s.themeColor}`]: !!(s.fillMode && s.themeColor)
        },
        s.className
      )
    },
    /* @__PURE__ */ t.createElement("span", { className: `k-avatar-${s.type}` }, s.children)
  );
};
zs.propTypes = {
  className: r.string,
  type: r.oneOf(["text", "image", "icon"]),
  size: r.oneOf([null, "small", "medium", "large"]),
  rounded: r.oneOf([null, "small", "medium", "large", "full"]),
  fillMode: r.oneOf([null, "solid", "outline"]),
  /* eslint-disable max-len */
  themeColor: r.oneOf([null, "base", "dark", "error", "info", "inverse", "inverse", "light", "primary", "secondary", "success", "tertiary", "warning"])
};
const Fs = {
  animation: !0,
  expanded: !1,
  mode: "overlay",
  position: "start",
  mini: !1,
  dir: "ltr",
  width: 240,
  miniWidth: 50
}, ht = t.createContext(Fs), pt = t.forwardRef((e, s) => {
  const {
    className: n,
    style: i,
    text: a,
    icon: o,
    svgIcon: l,
    separator: c,
    disabled: d,
    selected: u,
    onSelect: m,
    index: h,
    tabIndex: p,
    children: g,
    ...b
  } = e, { expanded: y, mini: E, item: N } = t.useContext(ht), f = t.useRef(null), R = t.useCallback(
    () => {
      f.current && f.current.focus();
    },
    []
  );
  t.useImperativeHandle(s, () => ({
    element: f.current,
    focus: R,
    props: e
  }));
  const v = k(
    "k-drawer-item",
    {
      "k-selected": u,
      "k-disabled": d
    },
    n
  ), w = t.useCallback(
    (O) => {
      if (m && !d) {
        const A = {
          element: f.current,
          focus: R,
          props: e
        };
        m(A, h, O);
      }
    },
    [m, h, d]
  ), S = /* @__PURE__ */ t.createElement(t.Fragment, null, (o || l) && /* @__PURE__ */ t.createElement(Q, { name: o && jt(o), icon: l }), !y && E ? null : /* @__PURE__ */ t.createElement("span", { className: "k-item-text" }, a));
  return c ? /* @__PURE__ */ t.createElement("li", { className: "k-drawer-item k-drawer-separator", role: "separator" }) : /* @__PURE__ */ t.createElement(
    "li",
    {
      ref: f,
      className: v,
      style: i,
      role: "menuitem",
      "aria-label": a,
      "aria-disabled": d,
      onClick: w,
      tabIndex: Oe(p, d),
      ...b
    },
    N ? g : S
  );
});
pt.propTypes = {
  className: r.string,
  style: r.object,
  text: r.string,
  icon: r.string,
  svgIcon: De,
  separator: r.bool,
  selected: r.bool,
  disabled: r.bool,
  targetItem: r.any
};
pt.displayName = "KendoDrawerItem";
const Bs = 240, Ks = 50, Hs = { type: "slide", duration: 200 }, _s = { type: "slide", duration: 0 }, ft = t.forwardRef((e, s) => {
  const { children: n, className: i, style: a } = e;
  W(K);
  const o = ze(K), {
    animation: l,
    expanded: c,
    mode: d,
    position: u,
    onOverlayClick: m,
    mini: h,
    dir: p,
    width: g,
    miniWidth: b,
    items: y,
    item: E,
    onSelect: N
  } = t.useContext(ht), f = t.useRef(null), R = t.useCallback(
    () => {
      f.current && f.current.focus();
    },
    []
  ), v = typeof l != "boolean" ? l : l === !1 ? _s : Hs, w = g || Bs, S = b || Ks;
  t.useImperativeHandle(s, () => ({
    element: f.current,
    focus: R
  }));
  const O = t.useMemo(
    () => "k-widget k-drawer " + k(
      {
        "k-drawer-start": u === "start",
        "k-drawer-end": u === "end"
      },
      i
    ),
    [u]
  ), A = {
    opacity: 1,
    flexBasis: w,
    WebkitTransition: "all " + (v && v.duration) + "ms",
    /* Safari */
    transition: "all " + (v && v.duration) + "ms"
  }, D = {
    opacity: 1,
    transform: "translateX(0px)",
    WebkitTransition: "all " + (v && v.duration) + "ms",
    /* Safari */
    transition: "all " + (v && v.duration) + "ms"
  }, L = {
    opacity: h ? 1 : 0,
    flexBasis: h ? S : 0,
    WebkitTransition: "all " + (v && v.duration) + "ms",
    /* Safari */
    transition: "all " + (v && v.duration) + "ms"
  }, B = {
    opacity: 0,
    transform: "translateX(-100%)",
    WebkitTransition: "all " + (v && v.duration) + "ms",
    /* Safari */
    transition: "all " + (v && v.duration) + "ms"
  }, G = {
    opacity: 0,
    transform: "translateX(100%)",
    WebkitTransition: "all " + (v && v.duration) + "ms",
    /* Safari */
    transition: "all " + (v && v.duration) + "ms"
  }, ee = {
    transform: "translateX(0%)",
    WebkitTransitionDuration: (v && v.duration) + "ms",
    /* Safari */
    transitionDuration: (v && v.duration) + "ms"
  }, $ = c ? d === "push" ? A : D : d === "push" ? L : p === "ltr" && u === "start" || p === "rtl" && u === "end" ? h ? ee : B : h ? ee : G, x = y && /* @__PURE__ */ t.createElement(
    "ul",
    {
      className: "k-drawer-items",
      role: "menubar",
      "aria-label": "drawer-list",
      "aria-expanded": c
    },
    y.map(
      (j, Y) => {
        const Z = {
          index: Y,
          ...j,
          onSelect: N
        }, re = E || pt;
        return /* @__PURE__ */ t.createElement(re, { key: Y, ...Z });
      }
    )
  ), M = /* @__PURE__ */ t.createElement(
    "div",
    {
      style: v ? { ...$, ...a } : a,
      className: O,
      ref: f
    },
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: "k-drawer-wrapper",
        style: !c && h && d === "overlay" ? { width: S } : { width: w }
      },
      x || n
    ),
    o && /* @__PURE__ */ t.createElement(Fe, null)
  );
  return d === "overlay" ? /* @__PURE__ */ t.createElement(t.Fragment, null, c && /* @__PURE__ */ t.createElement("div", { className: "k-overlay", onClick: m }), M) : M;
});
ft.propTypes = {
  children: r.any,
  className: r.string,
  style: r.object,
  item: r.any,
  tabIndex: r.number
};
ft.displayName = "KendoDrawerNavigation";
const gt = t.forwardRef((e, s) => {
  W(K);
  const {
    expanded: n,
    mode: i,
    position: a,
    className: o,
    children: l,
    style: c,
    animation: d,
    mini: u,
    width: m,
    miniWidth: h,
    items: p,
    item: g,
    tabIndex: b,
    onOverlayClick: y,
    onSelect: E
  } = e, N = t.useRef(null), f = t.useCallback(
    () => {
      N.current && N.current.focus();
    },
    []
  );
  t.useImperativeHandle(s, () => ({
    element: N.current,
    focus: f
  }));
  const R = t.useCallback(
    (S, O, A) => {
      if (p && E) {
        const D = {
          itemTarget: S,
          itemIndex: O,
          syntheticEvent: A,
          nativeEvent: A && A.nativeEvent,
          target: void 0
        };
        E.call(void 0, D);
      }
    },
    [p, E]
  ), v = ve(N, e.dir), w = k(
    {
      "k-drawer-container": !0,
      "k-drawer-expanded": n,
      "k-drawer-overlay": i === "overlay",
      "k-drawer-push": i === "push",
      "k-drawer-mini": u
    },
    o
  );
  return /* @__PURE__ */ t.createElement(
    ht.Provider,
    {
      value: {
        animation: d,
        expanded: n,
        mode: i,
        position: a,
        mini: u,
        dir: v,
        items: p,
        item: g,
        width: m,
        miniWidth: h,
        onOverlayClick: y,
        onSelect: R
      }
    },
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: w,
        ref: N,
        dir: v,
        style: c,
        tabIndex: b
      },
      p && /* @__PURE__ */ t.createElement(ft, null),
      l
    )
  );
});
gt.propTypes = {
  animation: r.any,
  expanded: r.bool,
  children: r.any,
  className: r.string,
  dir: r.string,
  mode: r.string,
  position: r.string,
  mini: r.bool,
  style: r.object,
  tabIndex: r.number,
  width: r.number,
  miniWidth: r.number,
  selected: r.number,
  onSelect: r.func,
  onOverlayClick: r.func
};
const Ws = {
  animation: !0,
  expanded: !1,
  mode: "overlay",
  position: "start",
  mini: !1,
  dir: "ltr",
  width: 240,
  miniWidth: 50
};
gt.defaultProps = Ws;
gt.displayName = "KendoDrawer";
const xn = t.forwardRef((e, s) => {
  const { children: n, className: i, style: a } = e, o = t.useRef(null);
  t.useImperativeHandle(s, () => ({
    element: o.current
  }));
  const l = k(
    {
      "k-drawer-content": !0
    },
    i
  );
  return /* @__PURE__ */ t.createElement("div", { className: l, style: a, ref: o }, n);
});
xn.propTypes = {
  children: r.any,
  className: r.string,
  style: r.object
};
xn.displayName = "KendoDrawerContent";
const $s = {
  linear: !1,
  mode: "steps",
  value: 0
}, Tn = t.createContext($s), Rn = 400, Dn = 0, On = "stepper.optionalText", st = "stepper.progBarAriaLabel", Pn = {
  [On]: "(Optional)",
  [st]: "progressbar"
}, We = t.forwardRef((e, s) => {
  const {
    // content
    children: n,
    className: i,
    current: a,
    disabled: o,
    focused: l,
    icon: c,
    svgIcon: d,
    index: u,
    isValid: m,
    label: h,
    optional: p,
    style: g,
    tabIndex: b,
    text: y,
    ...E
  } = e, {
    animationDuration: N,
    isVertical: f,
    item: R,
    linear: v,
    mode: w,
    numOfSteps: S,
    value: O,
    onChange: A,
    onFocus: D,
    successIcon: L,
    errorIcon: B,
    successSVGIcon: G,
    errorSVGIcon: ee
  } = t.useContext(Tn), $ = t.useRef(null), x = t.useCallback(
    () => {
      $.current && ke($.current);
    },
    []
  ), M = t.useCallback(
    () => ({
      element: $.current,
      focus: x
    }),
    [x]
  );
  t.useImperativeHandle(s, M);
  const j = !v || u === O - 1 || u === O || u === O + 1, Y = w === "labels" || !!c && !!h, Z = en(), de = ((ne) => Z.toLanguageString(ne, Pn[ne]))(On), se = typeof N == "number" ? N : N !== !1 ? Rn : Dn, Ie = t.useCallback(
    (ne) => {
      A && !o && q(
        A,
        ne,
        M(),
        { value: u }
      );
    },
    [A, O, o]
  ), ue = t.useCallback(
    (ne) => {
      D && !o && q(
        D,
        ne,
        M(),
        void 0
      );
    },
    [D, o]
  ), H = t.useMemo(
    () => k(
      "k-step",
      {
        "k-step-first": u === 0,
        "k-step-last": S && u === S - 1,
        "k-step-done": u < O,
        "k-step-current": a,
        "k-step-optional": p,
        "k-step-error": m !== void 0 && !m,
        "k-step-success": m
      },
      {
        "k-disabled": o,
        "k-focus": l
      },
      i
    ),
    [u, S, O, a, p, o, l, m, i]
  ), _ = t.useMemo(
    () => ({
      maxWidth: f ? void 0 : `calc(100% / ${S})`,
      maxHeight: f ? `calc(100% / ${S})` : void 0,
      pointerEvents: j ? void 0 : "none",
      ...g
    }),
    [f, S, g, j]
  ), F = m ? L : B, V = F ? /* @__PURE__ */ t.createElement(
    "span",
    {
      className: "k-step-indicator-icon " + F,
      "aria-hidden": "true"
    }
  ) : /* @__PURE__ */ t.createElement(
    Q,
    {
      className: "k-step-indicator-icon",
      name: m ? "check-circle" : "exclamation-circle",
      icon: m ? G || Yn : ee || Zn
    }
  ), me = /* @__PURE__ */ t.createElement(t.Fragment, null, w !== "labels" ? /* @__PURE__ */ t.createElement(
    "span",
    {
      className: "k-step-indicator",
      "aria-hidden": !0,
      style: { transitionDuration: se + "ms" }
    },
    c || d ? !Y && m !== void 0 ? V : /* @__PURE__ */ t.createElement(Q, { className: "k-step-indicator-icon", name: c && jt(c), icon: d }) : m !== void 0 ? V : /* @__PURE__ */ t.createElement("span", { className: "k-step-indicator-text" }, y || u + 1)
  ) : null), Ee = /* @__PURE__ */ t.createElement("span", { className: "k-step-label" }, h && /* @__PURE__ */ t.createElement("span", { className: "k-step-text" }, h), Y && m !== void 0 && V, p && /* @__PURE__ */ t.createElement("span", { className: "k-step-label-optional" }, de)), he = /* @__PURE__ */ t.createElement(t.Fragment, null, me, Ee);
  return /* @__PURE__ */ t.createElement(
    "li",
    {
      ref: $,
      className: H,
      style: _,
      ...E
    },
    /* @__PURE__ */ t.createElement(
      "a",
      {
        className: "k-step-link",
        title: h || void 0,
        onClick: Ie,
        onFocus: ue,
        tabIndex: b || (l ? 0 : -1),
        "aria-current": a,
        "aria-disabled": o || !j || void 0,
        "aria-invalid": m !== void 0 && !m || void 0
      },
      R ? n : he
    )
  );
});
We.propTypes = {
  children: r.any,
  className: r.string,
  // content: PropTypes.any,
  current: r.bool,
  disabled: r.bool,
  icon: r.string,
  index: r.number,
  isValid: r.bool,
  label: r.string,
  optional: r.bool,
  style: r.object,
  tabIndex: r.number,
  text: r.string
};
const Us = {
  tabIndex: 0
};
We.defaultProps = Us;
We.displayName = "KendoStep";
const bt = t.forwardRef((e, s) => {
  W(K);
  const {
    animationDuration: n,
    children: i,
    className: a,
    disabled: o,
    errorIcon: l,
    errorSVGIcon: c,
    item: d,
    items: u,
    linear: m,
    mode: h,
    orientation: p,
    style: g,
    successIcon: b,
    successSVGIcon: y,
    onChange: E,
    onFocus: N
  } = e, R = en().toLanguageString(st, Pn[st]), v = t.useRef(null), w = t.useCallback(
    () => {
      v.current && ke(v.current);
    },
    []
  ), S = t.useCallback(
    () => ({
      element: v.current,
      focus: w
    }),
    [w]
  );
  t.useImperativeHandle(s, S);
  const O = e.value || Mn.value, [A, D] = t.useState(O), L = u ? u.length : 0, B = p === "vertical", G = Vt(v, e.dir), ee = typeof n == "number" ? n : n !== !1 ? Rn : Dn;
  t.useEffect(() => {
    D(O);
  }, [O]);
  const $ = t.useCallback(
    (H, _) => {
      const F = _ === O - 1, V = _ === O, me = _ === O + 1;
      O !== _ && E && !o && (!m || F || V || me) && (q(
        E,
        H,
        S(),
        { value: _ }
      ), D(_));
    },
    [O, m, E, o, D]
  ), x = t.useCallback(
    (H) => {
      let _ = H.value, F = H.syntheticEvent;
      $(F, _);
    },
    [$]
  ), M = t.useCallback(
    (H) => {
      N && !o && q(
        N,
        H.syntheticEvent,
        S(),
        void 0
      );
    },
    [N, o]
  ), j = t.useCallback(
    (H) => {
      $(H, A);
    },
    [$, A]
  ), Y = t.useCallback(
    (H) => {
      const _ = G === "rtl", F = A, V = u.length - 1;
      switch (H.keyCode) {
        case C.left:
          H.preventDefault(), !_ && F > 0 && D(F - 1), _ && F < V && D(F + 1);
          break;
        case C.right:
          H.preventDefault(), !_ && F < V && D(F + 1), _ && F > 0 && D(F - 1);
          break;
        case C.up:
          H.preventDefault(), !_ && F > 0 && D(F - 1), _ && F > 0 && D(F - 1);
          break;
        case C.down:
          H.preventDefault(), !_ && F < V && D(F + 1), _ && F < V && D(F + 1);
          break;
        case C.home:
          H.preventDefault(), D(0);
          break;
        case C.end:
          H.preventDefault(), D(V);
          break;
        case C.space:
          H.preventDefault();
          break;
        case C.enter:
          H.preventDefault(), u[F].disabled || j(H);
          break;
      }
    },
    [u, D, A, G, j]
  ), Z = t.useMemo(
    () => k(
      "k-stepper",
      {
        "k-stepper-linear": m
      },
      a
    ),
    [m, a]
  ), re = t.useMemo(
    () => ({
      display: "grid",
      gridTemplateColumns: B ? void 0 : "repeat(" + L * 2 + ", 1fr)",
      gridTemplateRows: B ? "repeat(" + L + ", 1fr)" : void 0,
      ...g
    }),
    [B, L, g]
  ), de = t.useMemo(
    () => k(
      "k-step-list",
      {
        "k-step-list-horizontal": !B,
        "k-step-list-vertical": B
      }
    ),
    [B]
  ), se = t.useMemo(
    () => ({
      gridColumnStart: B ? void 0 : 1,
      gridColumnEnd: B ? void 0 : -1,
      gridRowStart: B ? 1 : void 0,
      gridRowEnd: B ? -1 : void 0
    }),
    [B]
  ), Ie = t.useMemo(
    () => ({
      gridColumnStart: B ? void 0 : 2,
      gridColumnEnd: B ? void 0 : L * 2,
      gridRowStart: B ? 1 : void 0,
      gridRowEnd: B ? L : void 0,
      top: B ? 17 : void 0
    }),
    [B, L]
  ), ue = u && u.map((H, _) => {
    const F = {
      index: _,
      disabled: o || H.disabled,
      focused: _ === A,
      current: _ === O,
      ...H
    }, V = d || We;
    return /* @__PURE__ */ t.createElement(V, { key: _, ...F });
  });
  return /* @__PURE__ */ t.createElement(
    Tn.Provider,
    {
      value: {
        animationDuration: n,
        isVertical: B,
        item: d,
        linear: m,
        mode: h,
        numOfSteps: L,
        value: O,
        successIcon: b,
        successSVGIcon: y,
        errorIcon: l,
        errorSVGIcon: c,
        onChange: x,
        onFocus: M
      }
    },
    /* @__PURE__ */ t.createElement(
      "nav",
      {
        className: Z,
        style: re,
        dir: G,
        onKeyDown: Y
      },
      /* @__PURE__ */ t.createElement(
        "ol",
        {
          className: de,
          style: se
        },
        ue || i
      ),
      /* @__PURE__ */ t.createElement(
        ss,
        {
          style: Ie,
          animation: { duration: ee },
          ariaLabel: R,
          "aria-hidden": !0,
          max: L - 1,
          labelVisible: !1,
          orientation: p,
          reverse: p === "vertical",
          value: O,
          disabled: o,
          tabIndex: -1
        }
      )
    )
  );
});
bt.propTypes = {
  animationDuration: r.oneOfType([r.bool, r.number]),
  children: r.any,
  className: r.string,
  dir: r.string,
  disabled: r.bool,
  errorIcon: r.string,
  errorSVGIcon: De,
  item: r.any,
  items: r.any,
  linear: r.bool,
  mode: r.oneOf(["steps", "labels"]),
  orientation: r.oneOf(["horizontal", "vertical"]),
  style: r.object,
  successIcon: r.string,
  successSVGIcon: De,
  value: r.number.isRequired,
  onChange: r.func,
  onFocus: r.func
};
const Mn = {
  value: 0
};
bt.defaultProps = Mn;
bt.displayName = "KendoStepper";
const Ln = t.forwardRef((e, s) => {
  W(K);
  const {
    children: n,
    className: i,
    style: a,
    id: o
  } = e, l = t.useRef(null), c = t.useCallback(
    () => {
      l.current && ke(l.current);
    },
    []
  ), d = t.useCallback(
    () => ({
      element: l.current,
      focus: c
    }),
    [c]
  );
  t.useImperativeHandle(s, d);
  const u = ye(), m = t.useMemo(
    () => e.themeColor || Ve.themeColor,
    [e.themeColor]
  ), h = t.useMemo(
    () => e.position || Ve.position,
    [e.position]
  ), p = t.useMemo(
    () => e.positionMode || Ve.positionMode,
    [e.positionMode]
  ), g = t.useMemo(
    () => k(
      "k-appbar",
      {
        "k-appbar-top": h === "top",
        "k-appbar-bottom": h === "bottom",
        "k-appbar-static": p === "static",
        "k-appbar-sticky": p === "sticky",
        "k-appbar-fixed": p === "fixed",
        "k-appbar-light": m === "light",
        "k-appbar-dark": m === "dark",
        "k-appbar-inherit": m === "inherit"
      },
      i
    ),
    [h, p, m, i]
  );
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: g,
      style: a,
      id: o || u
    },
    n
  );
});
Ln.propTypes = {
  children: r.any,
  className: r.string,
  style: r.object,
  id: r.string,
  themeColor: r.string,
  position: r.oneOf(["top", "bottom"]),
  positionMode: r.oneOf(["static", "sticky", "fixed"])
};
const Ve = {
  themeColor: "light",
  position: "top",
  positionMode: "static"
};
Ln.displayName = "KendoAppBar";
const An = t.forwardRef((e, s) => {
  const {
    children: n,
    className: i,
    style: a
  } = e, o = t.useRef(null), l = t.useCallback(
    () => {
      o.current && ke(o.current);
    },
    []
  ), c = t.useCallback(
    () => ({
      element: o.current,
      focus: l
    }),
    [l]
  );
  t.useImperativeHandle(s, c);
  const d = t.useMemo(
    () => k(
      "k-appbar-section",
      i
    ),
    [i]
  );
  return /* @__PURE__ */ t.createElement("div", { className: d, style: a }, n);
});
An.propTypes = {
  children: r.any,
  className: r.string,
  style: r.object
};
An.displayName = "KendoAppBarSection";
const zn = t.forwardRef((e, s) => {
  const {
    children: n,
    className: i,
    style: a
  } = e, o = t.useRef(null), l = t.useCallback(
    () => {
      o.current && ke(o.current);
    },
    []
  ), c = t.useCallback(
    () => ({
      element: o.current,
      focus: l
    }),
    [l]
  );
  t.useImperativeHandle(s, c);
  const d = t.useMemo(
    () => k(
      "k-appbar-spacer",
      {
        "k-appbar-spacer-sized": a && a.width && a.width !== null
      },
      i
    ),
    [i, a]
  ), u = t.useMemo(
    () => ({
      flexBasis: a && a.width ? a.width : void 0
    }),
    [a]
  );
  return /* @__PURE__ */ t.createElement("span", { className: d, style: u }, n);
});
zn.propTypes = {
  children: r.any,
  className: r.string,
  style: r.object
};
zn.displayName = "KendoAppBarSpacer";
const qe = (e) => /* @__PURE__ */ t.createElement(
  lt,
  {
    onPress: e.onPress,
    onDrag: (s) => {
      e.onResize(s.event, !1, e.d);
    },
    onRelease: (s) => {
      e.onResize(s.event, !0, e.d);
    }
  },
  /* @__PURE__ */ t.createElement("div", { className: "k-resize-handle k-cursor-" + e.d + "-resize", style: { bottom: 0, right: 0, ...e.style } })
);
class js extends t.Component {
  constructor() {
    super(...arguments), this.handleResize = (s, n, i) => {
      s.originalEvent.preventDefault(), this.props.onResize(s, { end: n, direction: i });
    };
  }
  render() {
    const { resizable: s, onPress: n, rtl: i } = this.props;
    return s ? /* @__PURE__ */ t.createElement(t.Fragment, null, s !== "vertical" && /* @__PURE__ */ t.createElement(
      qe,
      {
        onPress: n,
        onResize: this.handleResize,
        d: "ew",
        style: i ? { top: 0, width: 9, left: 0, right: "" } : { top: 0, width: 9, right: 0, left: "" }
      }
    ), s !== "horizontal" && /* @__PURE__ */ t.createElement(qe, { onPress: n, onResize: this.handleResize, d: "ns", style: { left: 0, height: 9 } }), s === !0 && /* @__PURE__ */ t.createElement(
      qe,
      {
        onPress: n,
        onResize: this.handleResize,
        d: i ? "nesw" : "nwse",
        style: i ? { width: 9, height: 9, right: "", left: 0 } : { width: 9, height: 9, right: 0, left: "" }
      }
    )) : null;
  }
}
const $t = 200, it = class extends t.Component {
  constructor() {
    super(...arguments), this.state = {
      rtl: !1
    }, this.oldSize = {}, this.draggable = null, this.dragging = !1, this.resizing = !1, this.element = null, this.hintElement = null, this.ignoreDrag = !1, this.pressOffset = { x: 0, y: 0 }, this.pressXY = { x: 0, y: 0 }, this.currentTranslate = { x: 0, y: 0 }, this.preventDataOps = void 0, this.handleResize = (e, s) => {
      if (s.end) {
        this.handleRelease();
        return;
      }
      if (!this.element || !this.hintElement)
        return;
      const n = e.clientX, i = e.clientY;
      this.resizing = !0;
      const a = (s.direction !== "ns" ? n - this.pressXY.x : 0) * (this.state.rtl ? -1 : 1), o = s.direction !== "ew" ? i - this.pressXY.y : 0;
      if (this.dragElement && (this.state.rtl ? this.dragElement.style.marginLeft = -a + "px" : this.dragElement.style.marginRight = -a + "px", this.dragElement.style.height = `calc(100% + ${o}px)`), this.hintElement.classList.add("k-layout-item-hint-resize"), this.preventDataOps)
        return;
      let l = 0, c = 0;
      const d = this.element.getBoundingClientRect();
      a > d.width / this.props.defaultPosition.colSpan / 3 && (l = 1), a < -d.width / this.props.defaultPosition.colSpan / 1.25 && (l = -1), o > d.height / this.props.defaultPosition.rowSpan / 3 && (c = 1), o < -d.height / this.props.defaultPosition.rowSpan / 1.25 && (c = -1), (l !== 0 || c !== 0) && this.props.update(this.props.index, 0, 0, c, l);
    }, this.handlePress = (e) => {
      if (!this.dragElement)
        return;
      if (this.pressXY = {
        x: e.event.clientX,
        y: e.event.clientY
      }, this.ignoreDrag = !1, this.props.ignoreDrag && this.props.ignoreDrag(e.event.originalEvent)) {
        this.ignoreDrag = !0;
        return;
      }
      this.element && this.hintElement && (this.element.style.zIndex = "10", this.hintElement.style.display = "block"), this.dragElement.classList.remove("k-cursor-grab"), this.dragElement.classList.add("k-cursor-grabbing");
      const s = this.dragElement.getBoundingClientRect();
      this.pressOffset = {
        x: e.event.clientX - s.x,
        y: e.event.clientY - s.y
      };
    }, this.handleDrag = (e) => {
      if (this.ignoreDrag)
        return;
      const s = this.dragElement;
      if (e.event.originalEvent.defaultPrevented || !s)
        return;
      this.dragging = !0, e.event.originalEvent.preventDefault();
      const n = s.getBoundingClientRect();
      if (this.currentTranslate = {
        x: e.event.clientX - n.x - this.pressOffset.x + this.currentTranslate.x,
        y: e.event.clientY - n.y - this.pressOffset.y + this.currentTranslate.y
      }, s.style.transform = `translate(${this.currentTranslate.x}px, ${this.currentTranslate.y}px)`, s.style.transition = "transform 0s", this.preventDataOps)
        return;
      let i = 0, a = 0;
      this.currentTranslate.y > 0.7 * n.height / this.props.defaultPosition.rowSpan && (a = 1), this.currentTranslate.y < 0.7 * -n.height / this.props.defaultPosition.rowSpan && (a = -1), this.currentTranslate.x > 0.7 * n.width / this.props.defaultPosition.colSpan && (i = 1), this.currentTranslate.x < 0.7 * -n.width / this.props.defaultPosition.colSpan && (i = -1), this.props.update(this.props.index, a, this.state.rtl ? -i : i, 0, 0);
    }, this.handleRelease = () => {
      this.dragging = this.resizing = !1, this.currentTranslate = { x: 0, y: 0 }, this.element && this.hintElement && (this.element.style.zIndex = "1", this.hintElement.classList.remove("k-layout-item-hint-resize"), this.hintElement.style.display = "none");
      const e = this.dragElement;
      e && (e.style.transform = "translate(0px, 0px)", e.style.transition = `transform ${$t}ms cubic-bezier(0.2, 0, 0, 1) 0s`, e.style.marginRight = "0px", e.style.marginLeft = "0px", e.style.height = "100%", e.classList.remove("k-cursor-grabbing"), e.classList.add("k-cursor-grab"));
    };
  }
  get reorderable() {
    return this.props.reorderable !== void 0 ? this.props.reorderable : it.defaultProps.reorderable;
  }
  get dragElement() {
    return this.draggable ? this.draggable.element : void 0;
  }
  componentDidMount() {
    this.element && (getComputedStyle(this.element).direction === "rtl" && this.setState({
      rtl: !0
    }), this.hintElement && (this.hintElement.style.height = this.element.offsetHeight + "px", this.hintElement.style.width = this.element.offsetWidth + "px"));
  }
  render() {
    qt && clearTimeout && typeof clearTimeout == "function" && (clearTimeout(this.preventDataOps), this.preventDataOps = window.setTimeout(() => {
      this.preventDataOps = void 0;
    }, 200));
    const e = this.props.defaultPosition, s = this.props.resizable !== void 0 ? this.props.resizable : it.defaultProps.resizable, n = {
      gridColumnStart: e.col,
      gridColumnEnd: `span ${e.colSpan}`,
      gridRowStart: e.row,
      gridRowEnd: `span ${e.rowSpan}`,
      outline: "none",
      order: e.order,
      display: "none",
      ...this.props.hintStyle
    }, i = {
      gridColumnStart: e.col,
      gridColumnEnd: `span ${e.colSpan}`,
      gridRowStart: e.row,
      gridRowEnd: `span ${e.rowSpan}`,
      order: e.order
    }, a = /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: (o) => {
          this.draggable = o ? { element: o } : null;
        },
        className: k("k-tilelayout-item k-card", { "k-cursor-grab": this.reorderable }, this.props.className),
        style: { height: "100%", ...i, ...this.props.style }
      },
      this.props.children,
      /* @__PURE__ */ t.createElement(
        js,
        {
          onPress: this.handlePress,
          onResize: this.handleResize,
          resizable: s,
          rtl: this.state.rtl
        }
      )
    );
    return /* @__PURE__ */ t.createElement("div", { ref: (o) => {
      this.element = o;
    }, style: i }, /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: (o) => {
          this.hintElement = o;
        },
        style: { position: "absolute", ...n },
        className: k("k-layout-item-hint", this.props.hintClassName)
      }
    ), /* @__PURE__ */ t.createElement(
      lt,
      {
        ref: (o) => {
          this.draggable = o;
        },
        onDrag: this.props.reorderable ? this.handleDrag : void 0,
        onRelease: this.props.reorderable ? this.handleRelease : void 0,
        onPress: this.props.reorderable ? this.handlePress : void 0
      },
      a
    ));
  }
  /**
   * @hidden
   */
  getSnapshotBeforeUpdate(e) {
    return this.oldSize = {}, this.dragElement && (this.oldSize = this.dragElement.getBoundingClientRect()), null;
  }
  /**
   * @hidden
   */
  componentDidUpdate(e) {
    const s = this.dragElement;
    if (!s)
      return;
    const n = s.getBoundingClientRect(), i = this.oldSize;
    if (this.resizing) {
      const l = n.width - i.width;
      if (this.state.rtl) {
        const u = parseFloat(s.style.marginLeft || "0");
        s.style.marginLeft = u - l + "px";
      } else {
        const u = parseFloat(s.style.marginRight || "0");
        s.style.marginRight = u + l + "px";
      }
      this.pressXY.x += this.state.rtl ? -l : l;
      const c = n.height - i.height, d = parseFloat(s.style.height.substring(12));
      s.style.height = `calc(100% + ${d + c}px)`, this.pressXY.y += c;
    }
    const a = i.left - n.left, o = i.top - n.top;
    if (!(a === 0 && o === 0)) {
      if (this.dragging) {
        (e.defaultPosition.order !== this.props.defaultPosition.order || e.defaultPosition.col !== this.props.defaultPosition.col) && (this.currentTranslate.x = 0, this.currentTranslate.y = 0, s.style.transform = "");
        return;
      }
      Math.abs(o) < 15 && Math.abs(a) < 15 || requestAnimationFrame(() => {
        const l = this.element;
        l && (l.style.transform = `translate(${a}px, ${o}px)`, l.style.transition = "transform 0s", requestAnimationFrame(() => {
          l.style.transform = "", l.style.transition = `transform ${$t}ms cubic-bezier(0.2, 0, 0, 1) 0s`;
        }));
      });
    }
  }
};
let $e = it;
$e.propTypes = {
  defaultPosition: r.object.isRequired,
  style: r.object,
  className: r.string,
  hintStyle: r.object,
  hintClassName: r.string,
  header: r.any,
  body: r.any,
  item: r.any,
  resizable: r.oneOf(["horizontal", "vertical", !0, !1]),
  reorderable: r.bool
};
$e.displayName = "KendoTileLayoutItem";
$e.defaultProps = {
  resizable: !0,
  reorderable: !0
};
const Vs = {
  column: "k-grid-flow-col",
  row: "k-grid-flow-row",
  "column dense": "k-grid-flow-col-dense",
  "row dense": "k-grid-flow-row-dense",
  unset: "k-grid-flow-unset"
};
class Fn extends t.Component {
  constructor(s) {
    super(s), this._element = null, this.state = { positions: (this.props.items || []).map((n, i) => Object.assign({ order: i, rowSpan: 1, colSpan: 1 }, n.defaultPosition)) }, this.showLicenseWatermark = !1, this.focus = () => {
      this._element && this._element.focus();
    }, this.update = (n, i, a, o = 0, l = 0) => {
      if (i === 0 && a === 0 && !l && !o)
        return;
      let c = !1;
      const d = this.state.positions.map((b) => Object.assign({}, b)), u = d[n], m = d.find((b) => b.order === u.order + i);
      m && m !== u && (u.order += i, m.order += -i, c = !0);
      const h = u.col + a;
      a !== 0 && h >= 1 && h + u.colSpan <= (this.props.columns || 3) + 1 && (u.col = h, c = !0);
      const p = u.colSpan + l;
      l && p >= 1 && p + u.col <= (this.props.columns || 3) + 1 && (u.colSpan = p, c = !0);
      const g = u.rowSpan + o;
      o && g >= 1 && (u.rowSpan = g, c = !0), c && (this.setState({ positions: d }), q(this.props.onReposition, {}, this, { value: d }));
    }, W(K), this.showLicenseWatermark = ze(K);
  }
  /**
   * Gets the HTML element of the TileLayout component.
   */
  get element() {
    return this._element;
  }
  /**
   * @hidden
   */
  static getDerivedStateFromProps(s, n) {
    return s.positions ? {
      positions: s.positions.map((i, a) => Object.assign({ order: a, rowSpan: 1, colSpan: 1 }, i))
    } : s.items && (!n.positions || s.items.length !== n.positions.length) ? {
      positions: s.items.map((i, a) => Object.assign({ order: a, rowSpan: 1, colSpan: 1 }, i.defaultPosition))
    } : null;
  }
  render() {
    const {
      className: s,
      columns: n = 3,
      columnWidth: i = "1fr",
      gap: a,
      rowHeight: o = "1fr",
      style: l,
      autoFlow: c = "column",
      items: d = []
    } = this.props, u = a ? `${typeof a.rows == "number" ? a.rows + "px" : a.rows} ${typeof a.columns == "number" ? a.columns + "px" : a.columns}` : 16, m = {
      gridTemplateColumns: `repeat(${n}, minmax(0px, ${typeof i == "number" ? i + "px" : i}))`,
      gridAutoRows: `minmax(0px, ${typeof o == "number" ? o + "px" : o})`,
      gap: u,
      padding: u,
      ...l
    };
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: (h) => {
          this._element = h;
        },
        dir: this.props.dir,
        className: k("k-tilelayout k-pos-relative", Vs[c], s),
        style: m,
        id: this.props.id,
        children: d.map(
          (h, p) => /* @__PURE__ */ t.createElement(t.Fragment, { key: this.props.dataItemKey ? qn(this.props.dataItemKey)(h) : p }, /* @__PURE__ */ t.createElement(
            $e,
            {
              update: this.update,
              defaultPosition: this.state.positions[p],
              index: p,
              resizable: h.resizable,
              reorderable: h.reorderable,
              style: h.style,
              className: h.className,
              hintClassName: h.hintClassName,
              hintStyle: h.hintStyle,
              ignoreDrag: this.props.ignoreDrag
            },
            h.item ? h.item : /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: "k-tilelayout-item-header k-card-header" }, t.isValidElement(h.header) ? h.header : /* @__PURE__ */ t.createElement("h5", { className: "k-card-title" }, h.header)), /* @__PURE__ */ t.createElement("div", { className: "k-tilelayout-item-body k-card-body" }, h.body))
          ), this.showLicenseWatermark && /* @__PURE__ */ t.createElement(Fe, null))
        )
      }
    );
  }
}
Fn.propTypes = {
  id: r.string,
  style: r.object,
  className: r.string,
  dir: r.string,
  gap: r.object,
  columns: r.number,
  columnWidth: r.oneOfType([r.number, r.string]),
  rowHeight: r.oneOfType([r.number, r.string]),
  dataItemKey: r.string,
  items: r.array,
  positions: r.array,
  autoFlow: r.oneOf(["column", "row", "column dense", "row dense", "unset"]),
  onReposition: r.func,
  ignoreDrag: r.func
};
Fn.displayName = "KendoTileLayout";
const qs = {
  vertical: "k-bottom-nav-item-flow-vertical",
  horizontal: "k-bottom-nav-item-flow-horizontal"
}, Gs = {
  fixed: "k-pos-fixed",
  sticky: "k-pos-sticky"
}, Ue = t.forwardRef((e, s) => {
  W(K);
  const n = t.useRef(null);
  t.useImperativeHandle(
    s,
    () => ({
      element: n.current
    })
  );
  const {
    className: i,
    style: a,
    selected: o,
    disabled: l,
    item: c,
    render: d,
    dataItem: u,
    icon: m,
    svgIcon: h,
    text: p,
    id: g,
    onSelect: b,
    onKeyDown: y,
    index: E,
    tabIndex: N
  } = e, f = t.useMemo(
    () => k(
      "k-bottom-nav-item",
      {
        "k-selected": o,
        "k-disabled": l
      },
      i
    ),
    [o, l, i]
  ), R = t.useCallback(
    (A) => {
      b && E !== void 0 && !l && b(A, E);
    },
    [b, E, l]
  ), v = t.useCallback(
    (A) => {
      y && E !== void 0 && !l && y(A, E);
    },
    [y, E, l]
  ), w = d, S = c, O = /* @__PURE__ */ t.createElement(
    "span",
    {
      ref: n,
      className: f,
      style: a,
      role: "link",
      id: g,
      tabIndex: N,
      onClick: R,
      onKeyDown: v,
      "aria-current": o,
      "aria-disabled": l
    },
    S ? /* @__PURE__ */ t.createElement(S, { itemIndex: E, item: u }) : /* @__PURE__ */ t.createElement(t.Fragment, null, (m || h) && /* @__PURE__ */ t.createElement(Q, { className: "k-bottom-nav-item-icon", name: m, icon: h, size: "xlarge" }), p && /* @__PURE__ */ t.createElement("span", { className: "k-bottom-nav-item-text", style: { userSelect: "none" } }, p))
  );
  return w !== void 0 ? w.call(void 0, O, e) : O;
}), Xs = {
  tabIndex: 0
};
Ue.propTypes = {
  className: r.string,
  style: r.object,
  id: r.string,
  disabled: r.bool,
  selected: r.bool,
  icon: r.string,
  svgIcon: De,
  text: r.string,
  tabIndex: r.number
};
Ue.defaultProps = Xs;
Ue.displayName = "KendoReactBottomNavigationItem";
const vt = t.forwardRef((e, s) => {
  W(K);
  const n = t.useRef(null), i = t.useCallback(
    () => {
      n.current && ke(n.current);
    },
    []
  ), a = t.useCallback(
    () => ({
      element: n.current,
      focus: i
    }),
    [i]
  );
  t.useImperativeHandle(s, a);
  const {
    positionMode: o = fe.positionMode,
    itemFlow: l = fe.itemFlow,
    border: c = fe.border,
    className: d,
    items: u,
    item: m,
    itemRender: h,
    disabled: p,
    style: g,
    id: b,
    onSelect: y,
    onKeyDown: E
  } = e, N = ye(), f = ve(n, e.dir), R = t.useMemo(
    () => e.fillMode === null || e.fill === null ? null : e.fill || e.fillMode || fe.fillMode,
    [e.fillMode, e.fill]
  ), v = t.useMemo(
    () => e.themeColor || fe.themeColor,
    [e.themeColor]
  ), w = t.useMemo(
    () => k(
      "k-bottom-nav",
      Gs[o],
      qs[l],
      {
        [`k-bottom-nav-${R}`]: R,
        [`k-bottom-nav-${R}-${v}`]: !!(R && v),
        "k-bottom-nav-border": c,
        "k-disabled": p
      },
      d
    ),
    [o, v, R, l, c, p, d]
  ), S = t.useCallback(
    (D, L) => {
      u && !u[L].disabled && y && q(
        y,
        D,
        a(),
        {
          itemTarget: u[L],
          itemIndex: L
        }
      );
    },
    [u, y]
  ), O = t.useCallback(
    (D, L) => {
      S(D, L);
    },
    [S]
  ), A = t.useCallback(
    (D, L) => {
      switch (D.keyCode) {
        case C.enter:
        case C.space:
          S(D, L), D.preventDefault();
          break;
      }
      q(
        E,
        D,
        a(),
        void 0
      );
    },
    [S, E]
  );
  return /* @__PURE__ */ t.createElement(
    "nav",
    {
      ref: n,
      className: w,
      style: g,
      id: b || N,
      dir: f
    },
    u && u.map((D, L) => /* @__PURE__ */ t.createElement(
      Ue,
      {
        ...D,
        key: L,
        index: L,
        id: `${b || N}-${L}`,
        disabled: p || D.disabled,
        selected: D.selected,
        dataItem: D,
        item: m,
        render: h,
        onSelect: O,
        onKeyDown: A
      }
    ))
  );
}), fe = {
  themeColor: "primary",
  fillMode: "flat",
  itemFlow: "vertical",
  positionMode: "fixed",
  border: !0
};
vt.propTypes = {
  className: r.string,
  style: r.object,
  id: r.string,
  dir: r.string,
  themeColor: r.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "inverse"
  ]),
  fill: r.oneOf(["solid", "flat"]),
  fillMode: r.oneOf(["solid", "flat"]),
  itemFlow: r.oneOf(["vertical", "horizontal"]),
  border: r.bool,
  disabled: r.bool,
  selected: r.number,
  onSelect: r.func
};
vt.defaultProps = fe;
vt.displayName = "KendoReactBottomNavigation";
const kt = t.forwardRef((e, s) => {
  W(K);
  const n = t.useRef(null), i = t.useCallback(
    () => ({
      element: n.current
    }),
    []
  );
  t.useImperativeHandle(s, i);
  const { className: a, style: o, id: l, children: c } = e, d = ye(), u = t.useMemo(
    () => e.orientation || Le.orientation,
    [e.orientation]
  ), m = u === "horizontal", h = t.useMemo(
    () => e.align && e.align.horizontal ? e.align.horizontal : Le.hAlign,
    [e.align]
  ), p = t.useMemo(
    () => e.align && e.align.vertical ? e.align.vertical : Le.vAlign,
    [e.align]
  ), g = t.useMemo(
    () => k(
      "k-stack-layout",
      {
        "k-hstack": u === "horizontal",
        "k-vstack": u === "vertical",
        "k-justify-content-start": m && h === "start" || !m && p === "top",
        "k-justify-content-center": m && h === "center" || !m && p === "middle",
        "k-justify-content-end": m && h === "end" || !m && p === "bottom",
        "k-justify-content-stretch": m && h === "stretch" || !m && p === "stretch",
        "k-align-items-start": !m && h === "start" || m && p === "top",
        "k-align-items-center": !m && h === "center" || m && p === "middle",
        "k-align-items-end": !m && h === "end" || m && p === "bottom",
        "k-align-items-stretch": !m && h === "stretch" || m && p === "stretch"
      },
      a
    ),
    [u, m, h, p, a]
  ), b = {
    gap: `${typeof e.gap == "number" ? e.gap + "px" : e.gap}`,
    ...o
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: n,
      className: g,
      style: b,
      id: l || d
    },
    c
  );
}), Le = {
  orientation: "horizontal",
  hAlign: "stretch",
  vAlign: "stretch"
};
kt.propTypes = {
  className: r.string,
  style: r.object,
  children: r.any,
  id: r.string,
  orientation: r.oneOf(["horizontal", "vertical"]),
  gap: r.oneOfType([r.string, r.number]),
  align: r.shape({
    vertical: r.oneOf(["top", "middle", "bottom", "stretch"]),
    horizontal: r.oneOf(["start", "center", "end", "stretch"])
  })
};
kt.defaultProps = Le;
kt.displayName = "KendoReactStackLayout";
const yt = t.forwardRef((e, s) => {
  W(K);
  const n = t.useRef(null), i = t.useCallback(
    () => ({
      element: n.current
    }),
    []
  );
  t.useImperativeHandle(s, i);
  const { className: a, style: o, id: l, children: c, gap: d } = e, u = ye(), m = t.useMemo(
    () => e.align && e.align.horizontal ? e.align.horizontal : rt.hAlign,
    [e.align]
  ), h = t.useMemo(
    () => e.align && e.align.vertical ? e.align.vertical : rt.vAlign,
    [e.align]
  ), p = t.useMemo(
    () => k(
      "k-grid-layout",
      {
        "k-justify-items-start": m === "start",
        "k-justify-items-center": m === "center",
        "k-justify-items-end": m === "end",
        "k-justify-items-stretch": m === "stretch",
        "k-align-items-start": h === "top",
        "k-align-items-center": h === "middle",
        "k-align-items-end": h === "bottom",
        "k-align-items-stretch": h === "stretch"
      },
      a
    ),
    [m, h, a]
  ), g = d ? `${typeof d.rows == "number" ? d.rows + "px" : d.rows} ${typeof d.cols == "number" ? d.cols + "px" : d.cols}` : void 0, b = e.rows && e.rows.map((N) => `${typeof N.height == "number" ? N.height + "px" : N.height}`).join(" "), y = e.cols && e.cols.map((N) => `${typeof N.width == "number" ? N.width + "px" : N.width}`).join(" "), E = {
    gap: g,
    gridTemplateColumns: y,
    gridTemplateRows: b,
    ...o
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: n,
      className: p,
      style: E,
      id: l || u
    },
    c
  );
}), rt = {
  hAlign: "stretch",
  vAlign: "stretch",
  gap: void 0
};
yt.propTypes = {
  className: r.string,
  style: r.object,
  children: r.any,
  id: r.string,
  gap: r.shape({
    rows: r.oneOfType([r.string, r.number]),
    columns: r.oneOfType([r.string, r.number])
  }),
  align: r.shape({
    vertical: r.oneOf(["top", "middle", "bottom", "stretch"]),
    horizontal: r.oneOf(["start", "center", "end", "stretch"])
  })
};
yt.defaultProps = rt;
yt.displayName = "KendoReactGridLayout";
const Bn = t.forwardRef((e, s) => {
  W(K);
  const n = t.useRef(null), i = t.useCallback(
    () => ({
      element: n.current
    }),
    []
  );
  t.useImperativeHandle(s, i);
  const { className: a, style: o, id: l, children: c, row: d, col: u, rowSpan: m, colSpan: h } = e, p = ye(), g = {
    gridArea: `${d || "auto"} / ${u || "auto"} / ${m ? "span " + m : "auto"} / ${h ? "span " + h : "auto"}`,
    ...o
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: n,
      className: a,
      style: g,
      id: l || p
    },
    c
  );
});
Bn.propTypes = {
  className: r.string,
  style: r.object,
  children: r.any,
  id: r.string
};
Bn.displayName = "KendoReactGridLayoutItem";
const It = t.forwardRef((e, s) => {
  W(K);
  const n = t.useRef(null), i = t.useRef(null), a = t.useCallback(
    () => {
      i.current && i.current.focus();
    },
    [i]
  );
  return t.useImperativeHandle(n, () => ({
    element: i.current,
    focus: a,
    props: e
  })), t.useImperativeHandle(s, () => n.current), /* @__PURE__ */ t.createElement(
    "li",
    {
      ref: i,
      id: e.id,
      style: e.style,
      className: k(
        "k-breadcrumb-item",
        {
          "k-breadcrumb-root-item": e.isFirstItem,
          "k-breadcrumb-last-item": e.isLastItem
        },
        e.className
      )
    },
    e.children
  );
}), Ys = {
  id: r.string,
  className: r.string,
  children: r.any,
  style: r.object
};
It.displayName = "KendoReactBreadcrumbListItem";
It.propTypes = Ys;
const Et = t.forwardRef((e, s) => {
  W(K);
  const n = t.useRef(null), i = t.useRef(null);
  return t.useImperativeHandle(n, () => {
    var a;
    return {
      element: ((a = i.current) == null ? void 0 : a.element) || null,
      props: e
    };
  }), t.useImperativeHandle(s, () => n.current), /* @__PURE__ */ t.createElement(
    Q,
    {
      ref: i,
      id: e.id,
      "aria-hidden": !0,
      tabIndex: e.tabIndex,
      style: e.style,
      name: e.dir === "rtl" ? "chevron-left" : "chevron-right",
      icon: e.dir === "rtl" ? Jn : Jt,
      className: "k-breadcrumb-delimiter-icon",
      size: "xsmall"
    }
  );
}), Zs = {
  id: r.string,
  className: r.string,
  style: r.object,
  tabIndex: r.number,
  dir: r.string
};
Et.displayName = "KendoReactBreadcrumbDelimiter";
Et.propTypes = Zs;
const Ct = t.forwardRef((e, s) => {
  W(K);
  const n = t.useRef(null), i = t.useRef(null), a = t.useCallback(
    () => {
      i.current && i.current.focus();
    },
    [i]
  );
  t.useImperativeHandle(n, () => ({
    element: i.current,
    focus: a,
    props: e
  })), t.useImperativeHandle(s, () => n.current);
  const o = t.useCallback(
    (c) => {
      e.id && q(e.onItemSelect, c, c.target, { id: e.id });
    },
    [e.onItemSelect]
  ), l = t.useCallback(
    (c) => {
      e.id && q(e.onKeyDown, c, c.target, { id: e.id });
    },
    [e.onKeyDown]
  );
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      "aria-current": e.ariaCurrent ? e.ariaCurrent : e.isLast,
      role: "link",
      id: e.id,
      ref: i,
      style: e.style,
      dir: ve(i, e.dir),
      tabIndex: Oe(e.tabIndex, e.disabled),
      className: k(
        {
          "k-breadcrumb-root-link": e.isFirst,
          "k-breadcrumb-link": !e.isFirst,
          "k-breadcrumb-icontext-link": e.iconClass !== void 0 && e.text,
          "k-breadcrumb-icon-link": e.iconClass !== void 0 && !e.text,
          "k-disabled": e.disabled
        }
      ),
      onClick: o,
      onKeyDown: l
    },
    e.iconClass ? /* @__PURE__ */ t.createElement("span", { className: k(
      "k-icon",
      e.iconClass
    ) }) : e.icon ? e.icon : "",
    e.text && /* @__PURE__ */ t.createElement("span", { className: "k-breadcrumb-item-text" }, e.text)
  );
}), Js = {
  id: r.string,
  className: r.string,
  tabIndex: r.number,
  style: r.object,
  dir: r.string,
  disabled: r.bool,
  text: r.string,
  icon: r.node,
  iconClass: r.string,
  onClick: r.func,
  ariaCurrent: r.bool
};
Ct.displayName = "KendoReactBreadcrumbLink";
Ct.propTypes = Js;
const Nt = t.forwardRef((e, s) => {
  W(K);
  const n = t.useRef(null), i = t.useRef(null);
  return t.useImperativeHandle(n, () => ({
    element: i.current,
    props: e
  })), t.useImperativeHandle(s, () => n.current), /* @__PURE__ */ t.createElement(t.Fragment, null, e.rootItem ? /* @__PURE__ */ t.createElement(
    "ol",
    {
      id: e.id,
      ref: i,
      style: e.style,
      dir: ve(i, e.dir),
      tabIndex: Oe(e.tabIndex, e.disabled),
      className: k(
        "k-breadcrumb-root-item-container",
        {
          "k-disabled": e.disabled
        },
        e.className
      )
    },
    e.children
  ) : /* @__PURE__ */ t.createElement(
    "ol",
    {
      id: e.id,
      ref: i,
      style: e.style,
      dir: ve(i, e.dir),
      tabIndex: Oe(e.tabIndex, e.disabled),
      className: k(
        "k-breadcrumb-container !k-flex-wrap",
        {
          "k-disabled": e.disabled
        },
        e.className
      )
    },
    e.children
  ));
}), Qs = {
  id: r.string,
  className: r.string,
  children: r.element,
  tabIndex: r.number,
  style: r.object,
  dir: r.string,
  disabled: r.bool
};
Nt.displayName = "KendoReactBreadcrumbOrderedList";
Nt.propTypes = Qs;
const wt = t.forwardRef((e, s) => {
  W(K);
  const n = t.useRef(null), i = t.useRef(null), a = t.useMemo(
    () => e.breadcrumbOrderedList || Nt,
    [e.breadcrumbOrderedList]
  ), o = t.useMemo(
    () => e.breadcrumbListItem || It,
    [e.breadcrumbListItem]
  ), l = t.useMemo(
    () => e.breadcrumbDelimiter || Et,
    [e.breadcrumbDelimiter]
  ), c = t.useMemo(
    () => e.breadcrumbLink || Ct,
    [e.breadcrumbLink]
  ), d = t.useCallback(
    () => {
      i.current && i.current.focus();
    },
    [i]
  ), u = t.useMemo(
    () => e.disabled || !1,
    [e.disabled]
  );
  t.useImperativeHandle(n, () => ({
    element: i.current,
    focus: d,
    props: e
  })), t.useImperativeHandle(s, () => n.current);
  const m = ve(i, e.dir), h = (f) => {
    n.current && q(e.onItemSelect, f, f.target, { id: f.target.id });
  }, p = (f) => {
    n.current && q(e.onKeyDown, f, f.target, { id: f.target.id });
  }, g = e.valueField || Te.valueField, b = e.iconField || Te.iconField, y = e.iconClassField || Te.iconClassField, E = e.textField || Te.textField, N = e.size || "medium";
  return /* @__PURE__ */ t.createElement(
    "nav",
    {
      "aria-label": e.ariaLabel,
      id: e.id,
      style: e.style,
      ref: i,
      dir: m,
      className: k(
        "k-breadcrumb k-breadcrumb-wrap",
        {
          "k-rtl": m === "rtl",
          "k-disabled": u,
          "k-breadcrumb-md": !e.size,
          [`k-breadcrumb-${Ge.sizeMap[N] || N}`]: N
        },
        e.className
      )
    },
    /* @__PURE__ */ t.createElement(a, { rootItem: !0 }, /* @__PURE__ */ t.createElement(t.Fragment, null, e.data.map((f, R, v) => {
      const w = f[g];
      if (R === 0)
        return /* @__PURE__ */ t.createElement(
          o,
          {
            key: w,
            isFirstItem: !0,
            isLastItem: v.length - 1 === R
          },
          /* @__PURE__ */ t.createElement(
            c,
            {
              isLast: v.length - 1 === R,
              isFirst: !0,
              id: String(w),
              icon: f[b] || void 0,
              iconClass: f[y] ? String(f[y]) : void 0,
              text: f[E] ? String(f[E]) : void 0,
              disabled: f.disabled || !1,
              onItemSelect: h,
              onKeyDown: p,
              ...e
            }
          )
        );
    }))),
    /* @__PURE__ */ t.createElement(a, { rootItem: !1 }, /* @__PURE__ */ t.createElement(t.Fragment, null, e.data.map((f, R, v) => {
      const w = f[g];
      if (R !== 0)
        return /* @__PURE__ */ t.createElement(
          o,
          {
            key: w,
            isFirstItem: !1,
            isLastItem: v.length - 1 === R
          },
          /* @__PURE__ */ t.createElement(l, { dir: m }),
          /* @__PURE__ */ t.createElement(
            c,
            {
              isLast: v.length - 1 === R,
              isFirst: !1,
              id: String(w),
              icon: f[b] || void 0,
              iconClass: f[y] ? String(f[y]) : void 0,
              text: f[E] ? String(f[E]) : void 0,
              disabled: f.disabled || !1,
              onItemSelect: h,
              onKeyDown: p,
              ...e
            }
          )
        );
    })))
  );
}), ei = {
  id: r.string,
  style: r.object,
  className: r.string,
  breadcrumbOrderedList: r.elementType,
  breadcrumbListItem: r.elementType,
  breadcrumbDelimiter: r.elementType,
  breadcrumbLink: r.elementType,
  data: r.arrayOf(r.shape({
    id: r.string,
    text: r.string,
    icon: r.any,
    iconClass: r.string
  })),
  dir: r.oneOf(["ltr", "rtl"]),
  disabled: r.bool,
  valueField: r.string,
  textField: r.string,
  iconField: r.string,
  iconClassField: r.string,
  onItemSelect: r.func,
  ariaLabel: r.string
}, Te = {
  valueField: "id",
  textField: "text",
  iconField: "icon",
  iconClassField: "iconClass"
};
wt.displayName = "KendoReactBreadcrumb";
wt.propTypes = ei;
wt.defaultProps = Te;
const at = (e) => {
  const s = t.useRef(null), n = t.useCallback((i) => {
    e.onClick && e.onClick.call(void 0, {
      syntheticEvent: i,
      item: e.item,
      title: e.title
    });
  }, [e.item, e.title, e.onClick]);
  return t.useEffect(() => {
    s.current && e.focused && s.current.focus();
  }, [e.focused]), /* @__PURE__ */ t.createElement(
    "span",
    {
      style: e.style,
      tabIndex: e.tabIndex,
      className: k(
        "k-actionsheet-item",
        "k-cursor-pointer",
        e.disabled && "k-disabled",
        e.className
      ),
      ref: s,
      role: "button",
      "aria-disabled": e.disabled,
      onClick: n
    },
    /* @__PURE__ */ t.createElement("span", { className: "k-actionsheet-action" }, e.icon && /* @__PURE__ */ t.createElement("span", { className: "k-icon-wrap" }, e.icon), (e.title || e.description) && /* @__PURE__ */ t.createElement("span", { className: "k-actionsheet-item-text" }, e.title && /* @__PURE__ */ t.createElement("span", { className: "k-actionsheet-item-title" }, e.title), e.description && /* @__PURE__ */ t.createElement("span", { className: "k-actionsheet-item-description" }, e.description)))
  );
};
at.propTypes = {
  className: r.string,
  style: r.object,
  description: r.string,
  disabled: r.bool,
  group: r.oneOf(["top", "bottom"]),
  icon: r.element,
  title: r.string
};
const ot = "ActionSheetHeader", St = (e) => /* @__PURE__ */ t.createElement(
  "div",
  {
    className: k(
      "k-actionsheet-titlebar",
      e.className
    )
  },
  e.children
);
St.propTypes = {
  className: r.string
};
St.displayName = ot;
St.propTypes = {
  children: r.any
};
const Kn = "ActionSheetFooter", xt = (e) => /* @__PURE__ */ t.createElement(
  "div",
  {
    className: k(
      "k-actionsheet-footer",
      e.className
    )
  },
  e.children
);
xt.propTypes = {
  className: r.string
};
xt.displayName = Kn;
xt.propTypes = {
  children: r.any
};
const Hn = "ActionSheetContent", Tt = (e) => /* @__PURE__ */ t.createElement(
  "div",
  {
    className: k(
      "k-actionsheet-content",
      e.className
    )
  },
  e.children
);
Tt.propTypes = {
  className: r.string
};
Tt.displayName = Hn;
Tt.propTypes = {
  children: r.any
};
class Rt extends t.Component {
  /** @hidden */
  constructor(s) {
    super(s), this.actionSheetRef = t.createRef(), this.actionSheetTitleClass = "k-actionsheet-title", this.ariaLabeledBy = this.actionSheetTitleClass + 1, this.animationDuration = 300, this.bottomPosition = { bottom: "0", width: "100%" }, this.handleKeyDown = (n) => {
      this.props.navigatable && this.navigation.triggerKeyboardEvent(n);
    }, this.onTab = (n, i, a) => {
      a.preventDefault(), a.shiftKey ? i.focusPrevious(n) : i.focusNext(n);
    }, this.handleOverlayClick = (n) => {
      this.props.onOverlayClick && this.props.onOverlayClick.call(void 0, n), this.props.onClose && this.props.onClose.call(void 0, n), this.props.animation || this.hideActionSheet();
    }, this.handleItemClick = (n) => {
      this.props.onItemClick && this.props.onItemClick.call(void 0, n), this.props.onItemSelect && this.props.onItemSelect.call(void 0, n), this.props.animation || this.hideActionSheet();
    }, this.onEnter = (n, i, a) => {
      if (n.ariaDisabled)
        return;
      const o = n.className && n.className.indexOf ? n.className.indexOf("k-actionsheet-item") !== -1 : !1, l = i.elements.filter((c) => c.className.indexOf("k-actionsheet-item") !== -1);
      if (o && this.props.onItemClick) {
        a.preventDefault();
        const c = this.props.items[l.indexOf(n)];
        this.props.onItemClick.call(void 0, {
          syntheticEvent: a,
          item: c,
          title: c && c.title
        });
      }
      if (o && this.props.onItemSelect) {
        a.preventDefault();
        const c = this.props.items[l.indexOf(n)];
        this.props.onItemSelect.call(void 0, {
          syntheticEvent: a,
          item: c,
          title: c && c.title
        });
      }
      this.props.animation || this.hideActionSheet();
    }, this.onEscape = (n, i, a) => {
      this.props.onOverlayClick && (a.preventDefault(), this.props.onOverlayClick.call(void 0, a)), this.props.onClose && (a.preventDefault(), this.props.onClose.call(void 0, a)), this.props.animation || this.hideActionSheet();
    }, this.hideActionSheet = () => {
      this.setState({ show: !1 });
    }, this.children = (n) => {
      const i = {};
      return t.Children.forEach(n, (a) => {
        a && (i[a.type.displayName] = a);
      }), i;
    }, this.state = {
      show: !1,
      slide: !1
    }, W(K);
  }
  /** @hidden */
  componentDidMount() {
    this.props.expand && !this.state.show && this.setState({ show: !0 });
  }
  /** @hidden */
  componentDidUpdate(s, n) {
    const i = this.actionSheetRef.current;
    if (this.props.expand && !this.state.show && this.setState({ show: !0 }), this.props.expand && this.state.show && !this.state.slide && this.setState({ slide: !0 }), !this.props.expand && this.state.show && this.state.slide && this.setState({ slide: !1 }), n !== this.state && this.state.slide && i && !this.props.className && (i.style.setProperty("--kendo-actionsheet-height", "auto"), i.style.setProperty("--kendo-actionsheet-max-height", "none")), i && this.props.navigatable) {
      const o = [
        ".k-actionsheet-item",
        ...[
          ".k-actionsheet-footer",
          ".k-actionsheet-content",
          ".k-actionsheet-titlebar"
        ].map((l) => Gn.concat(this.props.navigatableElements).map(
          (c) => `${l} ${c}`
        )).flat()
      ];
      this.navigation = new ct({
        tabIndex: this.props.tabIndex || 0,
        root: this.actionSheetRef,
        rovingTabIndex: !1,
        selectors: o,
        keyboardEvents: {
          keydown: {
            Tab: this.onTab,
            Enter: this.onEnter,
            Escape: this.onEscape
          }
        }
      }), this.navigation.focusElement(this.navigation.first, null);
    }
  }
  /** @hidden */
  render() {
    const {
      title: s,
      subTitle: n,
      animationStyles: i,
      animation: a,
      expand: o,
      tabIndex: l,
      items: c
    } = this.props, d = c == null ? void 0 : c.filter((b) => !b.group || b.group === "top"), u = c == null ? void 0 : c.filter((b) => b.group === "bottom"), m = d && d.length > 0 && u && u.length > 0, h = this.children(this.props.children), p = this.props.animationDuration || this.animationDuration, g = this.state.slide && /* @__PURE__ */ t.createElement(
      "div",
      {
        className: k("k-actionsheet", this.props.className, {
          "k-actionsheet-bottom": !this.props.className
        }),
        role: "dialog",
        "aria-modal": "true",
        "aria-hidden": !1,
        "aria-labelledby": this.ariaLabeledBy,
        ref: this.actionSheetRef,
        onKeyDown: this.handleKeyDown
      },
      h[ot] && !s && !n && h[ot],
      (s || n) && /* @__PURE__ */ t.createElement("div", { className: "k-actionsheet-titlebar k-text-center" }, /* @__PURE__ */ t.createElement("div", { className: "k-actionsheet-titlebar-group k-hbox" }, /* @__PURE__ */ t.createElement("div", { className: this.actionSheetTitleClass, id: this.ariaLabeledBy }, s && /* @__PURE__ */ t.createElement("div", null, s), n && /* @__PURE__ */ t.createElement("div", { className: "k-actionsheet-subtitle" }, n)))),
      h[Hn] || /* @__PURE__ */ t.createElement("div", { className: "k-actionsheet-content" }, /* @__PURE__ */ t.createElement("div", { className: "k-list-ul", role: "group" }, d && d.map((b, y) => /* @__PURE__ */ t.createElement(
        at,
        {
          ...b,
          id: y,
          key: y,
          item: b,
          tabIndex: l || 0,
          onClick: this.handleItemClick
        }
      ))), m && /* @__PURE__ */ t.createElement("hr", { className: "k-hr" }), /* @__PURE__ */ t.createElement("div", { className: "k-list-ul", role: "group" }, u && u.map((b, y) => /* @__PURE__ */ t.createElement(
        at,
        {
          ...b,
          id: y + ((d == null ? void 0 : d.length) || 0),
          key: y,
          item: b,
          tabIndex: l || 0,
          onClick: this.handleItemClick
        }
      )))),
      h[Kn]
    );
    return /* @__PURE__ */ t.createElement(t.Fragment, null, o || this.state.show ? /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: "k-actionsheet-container" }, /* @__PURE__ */ t.createElement(
      "div",
      {
        className: "k-overlay",
        onClick: this.handleOverlayClick
      }
    ), a ? /* @__PURE__ */ t.createElement(
      ts,
      {
        transitionName: this.state.slide ? "slide-up" : "slide-down",
        onExited: this.hideActionSheet,
        transitionEnterDuration: p,
        transitionExitDuration: p,
        animationEnteringStyle: i || this.bottomPosition,
        animationEnteredStyle: i || this.bottomPosition,
        animationExitingStyle: i || this.bottomPosition,
        exit: !0,
        enter: !0,
        appear: !1
      },
      g
    ) : g)) : null);
  }
}
Rt.displayName = "KendoReactActionSheet";
Rt.propTypes = {
  items: r.array,
  subTitle: r.string,
  title: r.string,
  navigatable: r.bool,
  navigatableElements: r.array
};
Rt.defaultProps = {
  navigatable: !0,
  navigatableElements: []
};
const Dt = (e) => {
  const { title: n, subtitle: i, actions: a, images: o, description: l } = e.eventData, [c, d] = t.useState(e.eventData.opened || !1), [u, m] = t.useState(e.eventData.opened || !!e.collapsible), h = (b) => {
    if (d(!c), e.onChange) {
      const y = {
        syntheticEvent: b,
        nativeEvent: b.nativeEvent,
        eventData: e.eventData
      };
      e.onChange.call(void 0, y);
    }
  }, p = (b) => {
    if (e.onActionClick) {
      const y = {
        syntheticEvent: b,
        nativeEvent: b.nativeEvent,
        eventData: e.eventData
      };
      e.onActionClick.call(void 0, y);
    }
  }, g = () => /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(Cn, null, /* @__PURE__ */ t.createElement("div", { className: "k-card-description" }, /* @__PURE__ */ t.createElement("p", null, l), o && o.map((b, y) => /* @__PURE__ */ t.createElement(wn, { key: y, src: b.src })))), /* @__PURE__ */ t.createElement(Nn, null, a && a.map((b, y) => /* @__PURE__ */ t.createElement(
    "a",
    {
      key: y,
      href: b.url,
      className: "k-button k-button-md k-rounded-md k-button-flat k-button-flat-primary",
      onClick: p
    },
    b.text
  ))));
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      "data-testid": "k-timeline-card",
      className: k(
        "k-timeline-card",
        { "k-collapsed": e.collapsible && u }
      )
    },
    /* @__PURE__ */ t.createElement(
      _e,
      {
        "aria-live": "polite",
        "aria-describedby": e.id,
        "aria-atomic": "true",
        tabIndex: e.tabindex,
        role: e.horizontal ? "tabpanel" : "button",
        "aria-expanded": e.collapsible && u
      },
      /* @__PURE__ */ t.createElement(
        "span",
        {
          style: e.calloutStyle,
          className: k(
            "k-timeline-card-callout",
            "k-card-callout",
            { "k-callout-n": e.horizontal },
            { "k-callout-e": e.alternated && !e.horizontal },
            { "k-callout-w": !e.alternated && !e.horizontal }
          )
        }
      ),
      /* @__PURE__ */ t.createElement("div", { className: "k-card-inner" }, /* @__PURE__ */ t.createElement(In, null, /* @__PURE__ */ t.createElement(En, null, /* @__PURE__ */ t.createElement("span", { className: "k-event-title" }, n), e.collapsible && /* @__PURE__ */ t.createElement(
        "span",
        {
          onClick: (b) => h(b),
          className: "k-event-collapse k-button k-button-md k-rounded-md k-button-flat k-button-flat-base k-icon-button"
        },
        /* @__PURE__ */ t.createElement(Xe, { icon: Jt })
      )), i && /* @__PURE__ */ t.createElement(Sn, null, i)), e.collapsible ? /* @__PURE__ */ t.createElement(
        Qt,
        {
          transitionEnterDuration: e.transitionDuration || 400,
          transitionExitDuration: e.transitionDuration || 400,
          onBeforeEnter: () => m(!1),
          onAfterExited: () => m(!0)
        },
        c ? g() : null
      ) : g())
    )
  );
};
Dt.propTypes = {
  onChange: r.func,
  onActionClick: r.func
};
const fi = (e) => e.sort((n, i) => n.date.getTime() - i.date.getTime()), _n = (e) => {
  let s;
  return e.reduce((i, a) => (s !== a.date.getFullYear() ? (s = a.date.getFullYear(), i.push({ yearFlag: s }, a)) : i.push(a), i), []);
}, Wn = (e) => {
  const i = tn(), [a, o] = t.useState(!1), [l, c] = t.useState(!0), [d, u] = t.useState(), [m, h] = t.useState(0), [p, g] = t.useState(), [b, y] = t.useState(0), [E, N] = t.useState(0), [f, R] = t.useState(1), [v, w] = t.useState(), [S, O] = t.useState(), [A, D] = t.useState([0, 0, 0]), [L, B] = t.useState(0), [G, ee] = t.useState(1), $ = t.useRef(null), x = t.useRef(null), M = t.useRef(null), { eventsData: j, dateFormat: Y, navigatable: Z, onActionClick: re } = e, de = p ? `${p}%` : "150px", se = t.useRef(new ct({
    tabIndex: 0,
    root: $,
    selectors: [".k-timeline-scrollable-wrap"]
  }));
  t.useEffect(() => {
    $.current && e.navigatable && (setTimeout(() => {
      const I = se.current.first;
      I && I.setAttribute("tabindex", String(0));
    }, 0), se.current.keyboardEvents = {
      keydown: {
        ArrowRight: ue,
        ArrowLeft: H,
        End: F,
        Home: _
      }
    });
  }, [e.navigatable, f, b]), t.useEffect(() => {
    se.current.update();
  });
  const Ie = (I) => {
    Z && se.current && se.current.triggerKeyboardEvent(I);
  };
  t.useEffect(() => {
    var z;
    const I = qt && window.ResizeObserver && new window.ResizeObserver(Me), T = x.current, P = ((z = $ == null ? void 0 : $.current) == null ? void 0 : z.offsetWidth) || 0;
    return I && T && I.observe(T), V(), Me(), D([P, 0, -P]), () => {
      I && I.disconnect();
    };
  }, []), t.useEffect(() => {
    const I = x.current, T = I && I.children[f];
    if (T) {
      const P = T.offsetWidth, z = !(m >= 0);
      if (o(z), S) {
        const U = S.length * P > b * P * ((m * -1 + 100) / 100);
        c(U);
      }
      (I == null ? void 0 : I.offsetWidth) * -m / 100 >= I.children.length * P && (V(), Me(), h((T.offsetLeft - T.offsetWidth) / (b * T.offsetWidth) * 100 * -1)), Ot(T);
    }
  }, [b, p, f]);
  const ue = (I, T, P) => {
    if (x.current) {
      const z = x.current.children[f + 1], U = z && z.classList.contains("k-timeline-flag-wrap") ? f + 2 : f + 1;
      if (S && S.length <= U)
        return;
      b + E <= U && Ee(), Ne(U, P);
    }
  }, H = (I, T, P) => {
    if (x.current) {
      const z = x.current && x.current.children[f - 1], U = z && z.classList.contains("k-timeline-flag-wrap") ? f - 2 : f - 1;
      if (U <= 0)
        return;
      U < E && me(), Ne(U, P);
    }
  }, _ = (I, T, P) => {
    if (x.current) {
      if (f <= 1)
        return;
      const z = 1;
      he(!0, z, 0, 0), Ne(z, P);
    }
  }, F = (I, T, P) => {
    if (x.current) {
      const z = x.current && x.current.children.length - 1;
      if (z <= f)
        return;
      const U = Math.floor(z / b), we = U * -100, je = U * b;
      he(!0, z, je, we), Ne(z, P);
    }
  }, V = () => {
    const I = _n(j);
    O(I), w([I[f - 1], I[f], I[f + 1]]);
  }, me = () => {
    var T;
    if (x.current && S) {
      const P = E - b, z = E - 1, U = S[z] && ((T = S[z]) != null && T.yearFlag) ? z - 1 : z, we = m + 100 > 0 ? 0 : m + 100;
      he(!1, U, P, we);
    }
  }, Ee = () => {
    if (x.current && S) {
      const T = E + b, P = S[T] && S[T].yearFlag ? T + 1 : T, z = m - 100;
      he(!0, P, T, z);
    }
  }, he = (I, T, P, z) => {
    ne(I, T), Me(), N(P), h(z), R(T);
  }, ne = (I, T) => {
    if (v && S) {
      const P = Ce(I, G), z = Object.assign([], v, { [P]: S[T] });
      w(z), ee(P), B(I ? -100 : 100), setTimeout(() => {
        var Mt;
        const U = (Mt = $.current) == null ? void 0 : Mt.offsetWidth, we = Object.assign([], A, {
          [P]: 0,
          [Ce(!0, P)]: U,
          [Ce(!1, P)]: U && -U
        }), je = Object.assign([], z, {
          [Ce(!0, P)]: {},
          [Ce(!1, P)]: {}
        });
        w(je), D(we), B(0);
      }, e.transitionDuration || 300);
    }
  }, Ce = (I, T) => {
    const P = I ? T + 1 : T - 1;
    return v ? P < 0 ? v.length - 1 : P % v.length : 0;
  }, Ot = (I) => {
    var P;
    const T = (f - E) * I.offsetWidth + I.offsetWidth / 2 + (((P = M.current) == null ? void 0 : P.offsetWidth) || 0);
    u(T);
  }, Ne = (I, T) => {
    T.preventDefault(), I > f ? ne(!0, I) : I < f && ne(!1, I), R(I);
  }, Me = t.useCallback(() => {
    const I = x.current, T = I && I.children[f];
    if (I instanceof HTMLElement && T) {
      const P = Math.round(I.offsetWidth / 150);
      Ot(T), g(100 / P), y(P);
    }
  }, []), Vn = () => ({
    transitionDuration: "300ms"
  }), Pt = (I) => ({
    transform: `translateX(${I}%)`,
    transformOrigin: "left top"
  });
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: "k-timeline-track-wrap", ref: $, onKeyDown: Ie }, /* @__PURE__ */ t.createElement(
    "a",
    {
      ref: M,
      "aria-hidden": "true",
      onClick: () => a && me(),
      className: k(
        "k-timeline-arrow",
        "k-timeline-arrow-left",
        "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-icon-button",
        { "k-disabled": !a }
      )
    },
    /* @__PURE__ */ t.createElement(Xe, { icon: ae })
  ), /* @__PURE__ */ t.createElement(
    "a",
    {
      "aria-hidden": "true",
      onClick: () => l && Ee(),
      className: k(
        "k-timeline-arrow",
        "k-timeline-arrow-right",
        "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-icon-button",
        { "k-disabled": !l }
      )
    },
    /* @__PURE__ */ t.createElement(Xe, { icon: oe })
  ), /* @__PURE__ */ t.createElement("div", { className: "k-timeline-track" }, /* @__PURE__ */ t.createElement(
    "ul",
    {
      ref: x,
      className: "k-timeline-scrollable-wrap",
      role: "tablist",
      tabIndex: 0,
      style: { transform: `translateX(${m}%)` }
    },
    S && S.map((I, T) => I.yearFlag ? /* @__PURE__ */ t.createElement(
      "li",
      {
        role: "none",
        className: "k-timeline-track-item k-timeline-flag-wrap",
        style: { flex: `1 0 ${de}` },
        key: T
      },
      /* @__PURE__ */ t.createElement("span", { className: "k-timeline-flag" }, I.yearFlag)
    ) : /* @__PURE__ */ t.createElement(
      "li",
      {
        role: "tab",
        className: k(
          "k-timeline-track-item",
          { "k-focus": T === f }
        ),
        "aria-selected": T === f,
        style: { flex: `1 0 ${de}` },
        key: T
      },
      /* @__PURE__ */ t.createElement("div", { className: "k-timeline-date-wrap" }, /* @__PURE__ */ t.createElement("span", { className: "k-timeline-date" }, i.formatDate(I.date, Y))),
      /* @__PURE__ */ t.createElement(
        "span",
        {
          onClick: (P) => Ne(T, P),
          className: "k-timeline-circle"
        }
      )
    ))
  ))), /* @__PURE__ */ t.createElement("div", { className: "k-timeline-events-list" }, /* @__PURE__ */ t.createElement(
    "ul",
    {
      className: "k-timeline-scrollable-wrap",
      style: L === 0 ? { ...Pt(L) } : { ...Pt(L), ...Vn() }
    },
    v && v.map(
      (I, T) => /* @__PURE__ */ t.createElement(
        "li",
        {
          key: T,
          className: "k-timeline-event",
          style: { transform: `translate3d(${A[T]}px, 0px, 0px)` }
        },
        I && /* @__PURE__ */ t.createElement(
          Dt,
          {
            tabindex: A[T] === 0 ? 0 : -1,
            eventData: I,
            onActionClick: re,
            horizontal: !0,
            collapsible: !1,
            calloutStyle: { left: `${d}px` }
          }
        )
      )
    )
  )));
};
Wn.propTypes = {
  onActionClick: r.func
};
const $n = (e) => {
  const s = tn(), [n, i] = t.useState(), {
    collapsibleEvents: a,
    transitionDuration: o,
    eventsData: l,
    dateFormat: c,
    alterMode: d,
    navigatable: u,
    onChange: m,
    onActionClick: h
  } = e, p = t.useRef(null), g = t.useRef(new ct({
    tabIndex: 0,
    root: p,
    selectors: [".k-card-vertical"]
  }));
  t.useEffect(() => {
    p.current && e.navigatable && (setTimeout(() => {
      const f = g.current.first;
      f && f.setAttribute("tabindex", String(0));
    }, 0), g.current.keyboardEvents = {
      keydown: {
        Space: y,
        Enter: y
      }
    });
  }, [e.navigatable]), t.useEffect(() => {
    i(_n(l));
  }, []), t.useEffect(() => {
    g.current.update();
  });
  const b = (f) => {
    u && g.current && g.current.triggerKeyboardEvent(f);
  }, y = (f, R, v) => {
    v.preventDefault();
    const w = f.querySelector(".k-card-title .k-event-collapse");
    w && w.click();
  };
  let E = 0;
  const N = ye();
  return /* @__PURE__ */ t.createElement("ul", { ref: p, onKeyDown: b }, n && n.map((f, R) => {
    const v = (R + E) % 2 === 0;
    f.yearFlag && (E += 1);
    const w = N + "-" + R;
    return /* @__PURE__ */ t.createElement(t.Fragment, { key: R }, f.yearFlag ? /* @__PURE__ */ t.createElement("li", { className: "k-timeline-flag-wrap" }, /* @__PURE__ */ t.createElement("span", { className: "k-timeline-flag" }, f.yearFlag)) : /* @__PURE__ */ t.createElement("li", { className: k("k-timeline-event", { "k-reverse": v }) }, /* @__PURE__ */ t.createElement("div", { className: "k-timeline-date-wrap" }, /* @__PURE__ */ t.createElement("span", { className: "k-timeline-date", id: w }, s.formatDate(f.date, c))), /* @__PURE__ */ t.createElement("a", { className: "k-timeline-circle" }), /* @__PURE__ */ t.createElement(
      Dt,
      {
        id: w,
        tabindex: u ? 0 : -1,
        eventData: f,
        alternated: d && v,
        collapsible: a,
        transitionDuration: o,
        onChange: m,
        onActionClick: h
      }
    )));
  }));
};
$n.propTypes = {
  onActionClick: r.func
};
const ti = (e) => {
  const s = {
    alterMode: !1,
    collapsibleEvents: !0,
    dateFormat: "MMM dd, yyyy",
    ...e
  }, {
    collapsibleEvents: n,
    transitionDuration: i,
    className: a,
    alterMode: o,
    navigatable: l,
    horizontal: c,
    events: d,
    dateFormat: u,
    onChange: m,
    onActionClick: h
  } = s, [p, g] = t.useState(), b = t.useRef(null);
  return t.useEffect(() => {
    b.current && g(b.current.offsetWidth);
  }, []), /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: b,
      className: k(
        "k-timeline",
        {
          "k-timeline-collapsible": n,
          "k-timeline-vertical": !c,
          "k-timeline-alternating": o,
          "k-timeline-horizontal": c
        },
        a
      ),
      style: { width: `${p}px` }
    },
    c ? /* @__PURE__ */ t.createElement(
      Wn,
      {
        navigatable: l,
        eventsData: d,
        dateFormat: u,
        transitionDuration: i,
        onActionClick: h
      }
    ) : /* @__PURE__ */ t.createElement(
      $n,
      {
        navigatable: l,
        eventsData: d,
        dateFormat: u,
        alterMode: o,
        collapsibleEvents: n,
        transitionDuration: i,
        onChange: m,
        onActionClick: h
      }
    )
  );
};
ti.propTypes = {
  className: r.string
};
const ni = (e) => {
  const s = t.useRef(null);
  return t.useEffect(() => {
    e.show && setTimeout(() => {
      const n = s.current && s.current.element, i = n && n.querySelector(".k-menu-item"), a = Ut(i && i.ownerDocument);
      i && i !== a && i.focus();
    });
  }, [e.show]), /* @__PURE__ */ t.createElement(
    Xt,
    {
      show: e.show,
      offset: e.offset,
      popupClass: "k-menu-popup",
      animate: !1
    },
    /* @__PURE__ */ t.createElement(
      He,
      {
        vertical: !0,
        ...e,
        ref: s,
        className: k(
          "k-context-menu",
          e.className
        ),
        onClose: e.onClose,
        role: "menu"
      },
      e.children
    )
  );
};
ni.displayName = "KendoReactContextMenu";
const Un = t.forwardRef((e, s) => {
  W(K);
  const n = t.useRef(null), [i, a] = t.useState(!1), o = t.useCallback(
    () => ({ element: n.current }),
    []
  );
  t.useImperativeHandle(s, o);
  const {
    expanded: l = !1,
    disabled: c,
    title: d,
    subtitle: u,
    onAction: m,
    expandIcon: h,
    collapseIcon: p,
    expandSVGIcon: g,
    collapseSVGIcon: b
  } = e, y = t.useCallback(
    (w) => {
      q(m, w, o(), { expanded: l });
    },
    [m, l]
  ), E = t.useCallback(
    (w) => {
      (w.keyCode === C.enter || w.keyCode === C.space) && (w.preventDefault(), q(m, w, o(), { expanded: l }));
    },
    [m, l]
  ), N = t.useCallback(() => {
    e.disabled || a(!0);
  }, [e.disabled]), f = t.useCallback(() => {
    e.disabled || a(!1);
  }, [e.disabled]), { onFocus: R, onBlur: v } = Xn({ onFocus: N, onBlur: f });
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: n,
      className: k(
        "k-expander",
        e.className,
        {
          "k-expanded": l,
          "k-focus": i && !c,
          "k-disabled": c
        }
      ),
      onFocus: R,
      onBlur: v,
      style: e.style,
      id: e.id,
      dir: Vt(n, e.dir),
      onKeyDown: c ? void 0 : E
    },
    /* @__PURE__ */ t.createElement(
      "div",
      {
        role: "button",
        "aria-controls": e.ariaControls,
        "aria-expanded": l,
        "aria-disabled": c,
        tabIndex: Oe(e.tabIndex, c),
        className: "k-expander-header",
        onClick: c ? void 0 : y
      },
      d !== void 0 ? /* @__PURE__ */ t.createElement("div", { className: "k-expander-title" }, d) : void 0,
      /* @__PURE__ */ t.createElement("span", { className: "k-spacer" }),
      u !== void 0 ? /* @__PURE__ */ t.createElement("div", { className: "k-expander-sub-title" }, u) : void 0,
      /* @__PURE__ */ t.createElement("span", { className: "k-expander-indicator" }, /* @__PURE__ */ t.createElement(
        Q,
        {
          name: l ? p ? void 0 : "chevron-up" : h ? void 0 : "chevron-down",
          icon: l ? !b && !p ? Yt : b : !g && !h ? Zt : g,
          className: k(
            l ? {
              [String(p)]: !!p
            } : {
              [String(h)]: !!h
            }
          )
        }
      ))
    ),
    e.children
  );
});
Un.propTypes = {
  children: r.node,
  className: r.string,
  style: r.object,
  dir: r.string,
  id: r.string,
  tabIndex: r.number,
  title: r.node,
  subtitle: r.node,
  expandIcon: r.string,
  collapseIcon: r.string,
  expanded: r.bool,
  disabled: r.bool,
  onAction: r.func
};
Un.displayName = "KendoReactExpansionPanel";
const si = t.forwardRef((e, s) => /* @__PURE__ */ t.createElement(
  "div",
  {
    ref: s,
    ...e,
    className: k("k-expander-content-wrapper", e.className)
  },
  /* @__PURE__ */ t.createElement("div", { className: "k-expander-content" }, e.children)
));
si.displayName = "KendoReactExpansionPanelContent";
const jn = Gt(He);
jn.displayName = "KendoReactMenu";
const gi = Gt(dt);
jn.displayName = "KendoReactMenu";
export {
  Rt as ActionSheet,
  Tt as ActionSheetContent,
  xt as ActionSheetFooter,
  St as ActionSheetHeader,
  at as ActionSheetItem,
  Ln as AppBar,
  An as AppBarSection,
  zn as AppBarSpacer,
  zs as Avatar,
  vt as BottomNavigation,
  Ue as BottomNavigationItem,
  wt as Breadcrumb,
  Et as BreadcrumbDelimiter,
  Ct as BreadcrumbLink,
  It as BreadcrumbListItem,
  Nt as BreadcrumbOrderedList,
  _e as Card,
  Nn as CardActions,
  Cn as CardBody,
  As as CardFooter,
  In as CardHeader,
  wn as CardImage,
  Sn as CardSubtitle,
  En as CardTitle,
  ni as ContextMenu,
  gt as Drawer,
  xn as DrawerContent,
  pt as DrawerItem,
  ft as DrawerNavigation,
  Un as ExpansionPanel,
  si as ExpansionPanelContent,
  yt as GridLayout,
  Bn as GridLayoutItem,
  jn as Menu,
  He as MenuClassComponent,
  nn as MenuItem,
  dn as MenuItemArrow,
  un as MenuItemInternalsList,
  cn as MenuItemLink,
  vn as PanelBar,
  ce as PanelBarItem,
  Wt as PanelBarUtils,
  Ls as Splitter,
  Ns as SplitterBar,
  Ds as SplitterPane,
  kt as StackLayout,
  We as Step,
  bt as Stepper,
  gi as TabStrip,
  dt as TabStripClassComponent,
  hn as TabStripContent,
  tt as TabStripNavigation,
  mn as TabStripNavigationItem,
  ws as TabStripTab,
  Fn as TileLayout,
  ti as Timeline,
  _n as addYearsFlags,
  Hn as contentDisplayName,
  gs as downArrowName,
  gn as flatChildren,
  bn as flatVisibleChildren,
  Ts as flatVisibleItems,
  Kn as footerDisplayName,
  xs as getFirstId,
  fn as getInitialState,
  ot as headerDisplayName,
  Rs as isArrayEqual,
  pi as isPresent,
  vs as leftArrowName,
  pn as renderChildren,
  bs as rightArrowName,
  fi as sortEventList
};
